<template>
  <fieldset class="fieldset__second fieldset open">
      <legend @click="openLegend()">{{$t('form.secondFieldset.title')}}<svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8">
          <path id="Path_53" data-name="Path 53" d="M7,10l8,8,8-8Z" transform="translate(-7 -10)" fill="#7ac323"/>
        </svg>
      </legend>
      <slide-up-down v-model="this.legendStatus" :duration="400" :responsive="true">
        <div class="fieldset__second--wrapper fieldset__wrapper">
          <div class="fieldset__second--intro">{{$t("form.secondFieldset.intro")}}</div>
          <div class="fieldset__second--dynamic" id="fieldset__second--dynamic">
            <div class="fieldset__second--left" :class="{loading:this.mapState == 'loading'}">
              <div class="fieldset__second--input">
                <div class="fieldset__second--input-wrapper">
                  <input type="text" v-model="searchInputWithLabel" @input="searchSuggestion" @click="searchSuggestion(),activateSuggestions(),this.inputCheckEmpty = true" id="prijscalc__search" name="prijscalc__search" class="prijscalc_search" :class="{invalid:this.inputCheck == false}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" class="erase--input" @click="this.searchInputWithLabel = ''">
                    <path id="Icon_material-add" data-name="Icon material-add" d="M19,13H13v6H11V13H5V11h6V5h2v6h6Z" transform="translate(-5 -5)" fill="#fff"/>
                  </svg>
                   <ul v-if="showSuggestions == true" class="search-suggestion-wrapper" @mouseleave="showSuggestions = false">
                    <li class="suggestion__label" v-if="suggestionResult.provinces">{{$t("form.secondFieldset.labelProvincie")}}</li>
                    <li class="suggestion" v-for="(province, prov) in suggestionResult.provinces" :key="province.prov" @click="addToSearchInput(prov,'province',prov,'')">{{prov}}</li>
                    <li class="suggestion__label" v-if="suggestionResult.municipalities">{{$t("form.secondFieldset.labelGemeente")}}</li>
                    <li class="suggestion" v-for="(municipalitiy, muni) in suggestionResult.municipalities" :key="municipalitiy.muni" @click="addToSearchInput(municipalitiy,'municipality',muni,'')">
                     {{municipalitiy}}
                    </li>
                    <li class="suggestion__label" v-if="suggestionResult.submunicipalities">{{$t("form.secondFieldset.labelDeelgemeente")}}</li>
                    <li class="suggestion" v-for="(submunicipality, sub) in suggestionResult.submunicipalities" :key="submunicipality.sub" @click="addToSearchInput(submunicipality['input'],'sub_municipality',sub,submunicipality['postalcode'])">{{submunicipality["input"]}}</li>
                  </ul>
                </div>
                <button type="button" class="fieldset__second--add" @click="searchSingle(this.searchInput,this.suggestionType,this.selectedPostalCode)">{{$t("form.secondFieldset.buttonToevoegen")}}
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                    <path id="Icon_material-add" data-name="Icon material-add" d="M19,13H13v6H11V13H5V11h6V5h2v6h6Z" transform="translate(-5 -5)" fill="#fff"/>
                  </svg>
                </button>
                </div>
                  <div class="error-message" :class="{invalid:this.inputCheck == false}">
                   <i class="fi-cnsuxl-exclamation-mark"></i>
                   <small>{{$t("form.secondFieldset.foutmeldingSearch")}}</small>
                </div>
                <div class="error-message empty" :class="{invalid:this.inputCheckEmpty == false}">
                   <i class="fi-cnsuxl-exclamation-mark"></i>
                   <small>{{$t("form.secondFieldset.foutmeldingSearchInput")}}</small>
                </div>
              <div class="fieldset__second--header-results">
                <h3>{{$t("form.secondFieldset.labelSelectie")}}</h3>
                <div class="fieldset__second--header-distriMessage">
                  <div class="second--header-distriMessage" v-html="this.distributionMessage"></div>
                </div>
                <div class="fieldset__second--header">
                  <div class="fieldset__second--header-item">
                    <h4>Zone</h4>
                  </div>
                  <div class="fieldset__second--header-item">
                    <h4>{{$t('form.secondFieldset.labelTaal')}}</h4>
                    <div class="tooltip__wrapper">
                      <svg class="tooltip__trigger" xmlns="http://www.w3.org/2000/svg" width="13.333" height="13.333" viewBox="0 0 13.333 13.333">
                      <path id="Icon_material-info" data-name="Icon material-info" d="M8,1.333A6.667,6.667,0,1,0,14.667,8,6.669,6.669,0,0,0,8,1.333Zm.667,10H7.333v-4H8.667ZM8.667,6H7.333V4.667H8.667V6Z" transform="translate(-1.333 -1.333)" fill="#7ac323"/></svg>
                      <div class="tooltip">
                        <div class="tooltip__text">{{$t('form.secondFieldset.toolTipTaal')}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="fieldset__second--header-item">
                    <h4>{{$t('form.secondFieldset.labelAantal')}}</h4>
                    <div class="tooltip__wrapper">
                      <svg class="tooltip__trigger" xmlns="http://www.w3.org/2000/svg" width="13.333" height="13.333" viewBox="0 0 13.333 13.333">
                      <path id="Icon_material-info" data-name="Icon material-info" d="M8,1.333A6.667,6.667,0,1,0,14.667,8,6.669,6.669,0,0,0,8,1.333Zm.667,10H7.333v-4H8.667ZM8.667,6H7.333V4.667H8.667V6Z" transform="translate(-1.333 -1.333)" fill="#7ac323"/></svg>
                      <div class="tooltip">
                        <div class="tooltip__text">{{$t('form.secondFieldset.toolTipAantal')}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                 <div class="fieldset__second--results" v-for="(gewest, key, index) in allocatedSearchObjects" :key="index">
                  <div @click="toggleChecked(gewest),searchAdd('no-search','gewest',key,'','','','',gewest.checked,'','','')/*,getProvinces(key,gewest.checked)*/" class="fieldset__second--inner gewest fieldset__second--row" :class="{checked:gewest.checked}">
                    <div class="fieldset__second--name">
                      <svg  class="arrow" xmlns="http://www.w3.org/2000/svg" width="12" height="7.41" viewBox="0 0 12 7.41">
                        <path id="Icon_material-keyboard-arrow-down" data-name="Icon material-keyboard-arrow-down" d="M7.41,7.84,12,12.42l4.59-4.58L18,9.25l-6,6-6-6Z" transform="translate(-6 -7.84)" fill="#7ac323"/>
                      </svg>
                      {{key}}
                    </div>
                    <div class="fieldset__second--lang">{{gewest.languageCode}}</div>
                    <div class="fieldset__second--boxes">{{calculateBoxesGewesten(key)}}</div>
                    <!-- <div class="fieldset__second--check"><input type="checkbox" class="fieldset__second--state" :checked="gewest.checked" value="no" @click="toggleChecked(gewest),searchAdd('no-search','gewest',key,'','','','',gewest.checked,'','','')/*,getProvinces(key,gewest.checked)*/"/></div> -->
                  </div>

                  <div class="province" v-for="(province, i) in gewest['provinces']" :key="i">
                   <div class="fieldset__second--inner fieldset__second--row" :class="{checked:province.checked,active:this.statusArr[province.info]['status'] == true,inactive:this.statusArr[province.info]['status'] == false}">
                      <div class="fieldset__second--name" @click="toggleStatus(province,'province')">
                        <svg  class="arrow" xmlns="http://www.w3.org/2000/svg" width="12" height="7.41" viewBox="0 0 12 7.41">
                        <path id="Icon_material-keyboard-arrow-down" data-name="Icon material-keyboard-arrow-down" d="M7.41,7.84,12,12.42l4.59-4.58L18,9.25l-6,6-6-6Z" transform="translate(-6 -7.84)" fill="#7ac323"/>
                        </svg>
                        {{i}}
                      </div>
                      <div class="fieldset__second--lang"></div>
                      <div class="fieldset__second--boxes">{{calculateBoxesProvinces(key,i)}}</div>
                      <div class="fieldset__second--check"><input type="checkbox" class="fieldset__second--state" @click="toggleChecked(province),searchAdd('province','',key,i,'','','',province.checked,'','',province.loadStatus),searchAdd('no-search','province',key,i,'','','',province.checked,'','','')" :checked="province.checked" value="no" /></div>
                     <!-- <div class="fieldset__second--quit" @click="searchAdd('no-search','province-quit',key,i,'','','',province.checked,'','','')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                            <path id="Icon_material-add" data-name="Icon material-add" d="M19,13H13v6H11V13H5V11h6V5h2v6h6Z" transform="translate(-5 -5)" fill="#b2b2b2"/>
                        </svg>
                      </div> -->
                   </div>
                  <!--  <slide-up-down v-model="province.status" :duration="400"> -->
                    <div class="municipality fieldset__second--row" v-for="(municipality, il) in province['municipalities']" :key="il">
                      <div class="fieldset__second--inner fieldset__second--row" :class="{checked:municipality.checked,incomplete:municipality.completion == false,active: this.statusArr[province.info][municipality.municipality]['status'] == true,inactive:this.statusArr[province.info][municipality.municipality]['status'] == false}">
                        <div class="fieldset__second--name" @click="toggleStatus(municipality,'municipality')">
                         <svg  class="arrow" xmlns="http://www.w3.org/2000/svg" width="12" height="7.41" viewBox="0 0 12 7.41">
                          <path id="Icon_material-keyboard-arrow-down" data-name="Icon material-keyboard-arrow-down" d="M7.41,7.84,12,12.42l4.59-4.58L18,9.25l-6,6-6-6Z" transform="translate(-6 -7.84)" fill="#7ac323"/>
                        </svg>
                          {{il}}
                        </div>
                        <div class="fieldset__second--lang"></div>
                        <div class="fieldset__second--boxes">{{calculateBoxesMunicipalities(key,i,il)}}</div>
                        <div class="fieldset__second--check"><input type="checkbox" :checked="municipality.checked" class="fieldset__second--state" @click="toggleChecked(municipality),searchAdd('no-search','muni',key,i,il,ils,'',municipality.checked,'','','')" value="no" /></div>
                        <div class="fieldset__second--quit" @click="searchAdd('no-search','muni-quit',key,i,il,'','',municipality.checked,'','','')">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                            <path id="Icon_material-add" data-name="Icon material-add" d="M19,13H13v6H11V13H5V11h6V5h2v6h6Z" transform="translate(-5 -5)" fill="#b2b2b2"/>
                          </svg>
                        </div>
                      </div>
                     <slide-up-down v-model="municipality.status" :duration="400" :responsive="true">
                      <div class="fieldset__second--row submunicipality" v-for="(submunicipality, ils) in municipality['submunicipalities']" :key="ils">
                        <div class="fieldset__second--inner fieldset__second--row" :class="{checked:submunicipality.checked,incomplete:submunicipality.completion == false,active:this.statusArr[province.info][municipality.municipality][submunicipality.originalSubmuni]['status'] == true,inactive:this.statusArr[province.info][municipality.municipality][submunicipality.originalSubmuni]['status'] == false}">
                        <div class="fieldset__second--name" @click="toggleStatus(submunicipality,'submunicipality')">
                          <svg  class="arrow" xmlns="http://www.w3.org/2000/svg" width="12" height="7.41" viewBox="0 0 12 7.41">
                          <path id="Icon_material-keyboard-arrow-down" data-name="Icon material-keyboard-arrow-down" d="M7.41,7.84,12,12.42l4.59-4.58L18,9.25l-6,6-6-6Z" transform="translate(-6 -7.84)" fill="#7ac323"/>
                        </svg>
                          {{submunicipality.info}}
                        </div>
                        <div class="fieldset__second--lang">{{submunicipality.languageCode}}</div>
                        <div class="fieldset__second--boxes">{{calculateBoxesSubmuni(submunicipality.sectoren,'','',key,i,il,ils)}}</div>
                        <div class="fieldset__second--check"><input type="checkbox" :checked="submunicipality.checked" class="fieldset__second--state" value="yes" @click="toggleChecked(submunicipality),searchAdd('no-search','submuni',key,i,il,ils,'',submunicipality.checked,'','','')"/></div>
                        <div class="fieldset__second--quit" @click="searchAdd('no-search','submuni-quit',key,i,il,ils,'',submunicipality.checked,'','','')">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                            <path id="Icon_material-add" data-name="Icon material-add" d="M19,13H13v6H11V13H5V11h6V5h2v6h6Z" transform="translate(-5 -5)" fill="#b2b2b2"/>
                          </svg>
                        </div>
                      </div>
                    <slide-up-down v-model="submunicipality.status" :duration="400" :responsive="true">
                        <div class="fieldset__second--row sectoren" v-for="(sector, sec) in submunicipality['sectoren']" :key="sec">
                          <div class="fieldset__second--inner fieldset__second--row" :class="{checked:sector.checked,active:sector.sectorStatus == true,inactive:sector.sectorStatus == false}">
                            <div class="fieldset__second--name">
                              <svg class="bullet" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6">
                                <circle id="Ellipse_25" data-name="Ellipse 25" cx="3" cy="3" r="3" fill="#7ac323"/>
                              </svg>
                              {{sector.sector_name}}
                            </div>
                            <div class="fieldset__second--lang">{{sector.languageCode}}</div>
                            <div class="fieldset__second--boxes" v-bind:boxes="sector.netNumberOfBoxes">{{sector.netNumberOfBoxes}}</div>
                            <div class="fieldset__second--check"><input type="checkbox" :checked="sector.checked" class="fieldset__second--state" value="yes" @click="toggleChecked(sector),searchAdd('no-search','sectoren',key,i,il,ils,sector.sector_id,sector.checked,sector.netNumberOfBoxes,sector.grossNumberOfBoxes,'')"/></div>
                            <div class="fieldset__second--quit" @click="searchAdd('no-search','sectoren-quit',key,i,il,ils,sector.sector_id,sector.checked,sector.netNumberOfBoxes,sector.grossNumberOfBoxes,'')">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                                <path id="Icon_material-add" data-name="Icon material-add" d="M19,13H13v6H11V13H5V11h6V5h2v6h6Z" transform="translate(-5 -5)" fill="#b2b2b2"/>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </slide-up-down>
                      </div>
                    </slide-up-down>
                    </div>
                 <!--  </slide-up-down> -->
                  </div>
                </div>
              </div>
              <div class="fieldset__second--total-boxes">
                <div class="gross-boxes fieldset__second--total fieldset__second--totals">
                  <h4>{{$t('form.secondFieldset.brutoAantallen')}}</h4>
                  <div class="fieldset__second--total-number">{{this.totalGrossBoxes.toLocaleString('nl')}}</div>
                </div>
                 <div class="fieldset__second--total fieldset__second--totals">
                  <h4>{{$t('form.secondFieldset.nettoAantallen')}}</h4>
                  <div class="fieldset__second--total-number">{{this.totalNetBoxes.toLocaleString('nl')}}</div>
                </div>
                <div class="fieldset__second--total-boxes-nl fieldset__second--total"  v-if="this.totalBoxesNl != 0">
                  <div class="fieldset__second--total-label">waarvan NL</div>
                  <div class="fieldset__second--total-number">{{this.totalBoxesNl.toLocaleString('nl')}}</div>
                </div>
                <div class="fieldset__second--total-boxes-fr fieldset__second--total" v-if="this.totalBoxesFr != 0">
                  <div class="fieldset__second--total-label">waarvan FR</div>
                  <div class="fieldset__second--total-number">{{this.totalBoxesFr.toLocaleString('nl')}}</div>
                </div>
                <div class="fieldset__second--total-boxes-bil fieldset__second--total" v-if="this.totalBoxesBil != 0">
                  <div class="fieldset__second--total-label">waarvan Bilingual</div>
                  <div class="fieldset__second--total-number">{{this.totalBoxesBil.toLocaleString('nl')}}</div>
                </div>
                <div class="fieldset__second--total-boxes-NlFr fieldset__second--total" v-if="this.totalBoxesNlFr != 0">
                  <div class="ieldset__second--total-label">waarvan NL & FR</div>
                  <div class="fieldset__second--total-number">{{this.totalBoxesNlFr.toLocaleString('nl')}}</div>
                </div>
                <div class="fieldset__second--total-boxes-DuFr fieldset__second--total" v-if="this.totalBoxesDuFr != 0">
                  <div class="fieldset__second--total-label">waarvan FR & DE</div>
                  <div class="fieldset__second--total-number">{{this.totalBoxesDuFr.toLocaleString('nl')}}</div>
                </div>
              </div>
              <div class="fieldset__second--price">
                <h3>{{$t("form.secondFieldset.labelPrice")}}</h3>
                <div class="fieldset__second--price-totals">€ {{this.totalPrice}}</div>
              </div>
            </div>
            <div class="fieldset__second--right">
              <div class="fieldset__second--map" :class="{loading:this.mapState == 'loading'}">
                <div class="loader__wrapper">
                </div>
                <div class="loader">
                    <svg viewBox="0 0 100 100">
                      <defs>
                        <filter id="shadow">
                          <feDropShadow dx="0" dy="0" stdDeviation="1.5"
                            flood-color="#fff"/>
                        </filter>
                      </defs>
                      <circle class="spinner" style="fill:transparent;stroke:#fff;stroke-width: 7px;stroke-linecap: round;filter:url(#shadow);" cx="50" cy="50" r="45"/>
                  </svg>
                  </div>
                <div id="custom__map" class="custom__map"></div>
              </div>
            </div>
          </div>
        </div>
      </slide-up-down>
    </fieldset>
</template>

<script>
/*eslint-disable no-undef*/
/*import axios from 'axios';*/
import { Loader } from "@googlemaps/js-api-loader";
//import userData from '../assets/9951.json';

export default {
   props: {
    validationSecond:{
      type: String,
    },
    weightFromFirst:{
      type: Number,
    },
    yearFromFirst:{
      type: Number,
    },
    weekFromFirst:{
      type: Number,
    },
    weightValidity:{
      type: String,
    },
    inputCheckEmptyFirst:{
      type: Boolean,
    },
    validationFirst:{
      type: String,
    },
    pickerStatus:{
      type: Boolean,
    }
  },
  data(){
    return{
      geoFetched: {},
      searchInput: '',
      searchInputWithLabel: this.searchInput,
      reactiveArray: [],
      tests: [],
      arr:[1],
      map:{},
      legendStatus: false,
      showSuggestions: false,
      suggestionAdded: false,
      suggestionResult: [],
      sector_id: '',
      listResult: [],
      checked: false,
      searchedZipcode: '',
      allocatedSearchObjects: {'Vlaams Gewest':[],'Brussel Hoofdstedelijk Gewest':[],'Région Wallonne':[]},
      flowCheck:'',
      statusMunicipality: false,
      sumMunicipality: 0,
      mapState: '',
      mapLength: 0,
      boxes: 0,
      arrParsed: false,
      totalBoxesNl: 0,
      totalBoxesFr: 0,
      totalBoxesBil: 0,
      totalBoxesNlFr: 0,
      totalBoxesDuFr: 0,
      totalNetBoxes: 0,
      totalGrossBoxes: 0,
      totalSubmuniBoxes: 0,
      totalPrice: 0,
      arrPlacedSectors: [],
      polygones: [],
      suggestionLabel: '',
      suggestionType:'',
      status: true,
      inputCheck: true,
      inputCheckEmpty: true,
      provincesLoaded: false,
      allSectors:[],
      weight: 0,
      week: 0,
      year: 0,
      weightCheck: false,
      weightValidationFirst: "",
      weightSet: false,
      weekSet: false,
      boxesVlaamsGewest: 0,
      boxesBxl: 0,
      boxesWallone: 0,
      selectedPostalCode: "",
      distributionMessageArr: [],
      distributionMessageUnique: [],
      distributionMessage: "",
      sectorTypesArr: [],
      sectorTypesUnique: [],
      sectorStatus: '',
      subMuniArray: [],
      subMuniStatus: [],
      muniArray:[],
      provinceArray:[],
      provinceStatus:[],
      provStatus:"",
      muniStatus:"",
      submuniStatus: "",
      statusArr:[],
      distributionMessageStatus: true
    }
  },
  mounted: async function(){
    this.getNumbersGewest("Vlaams Gewest");
    this.getNumbersGewest("Brussel Hoofdstedelijk Gewest");
    this.getNumbersGewest("Région Wallonne");
    //console.log(this.boxesVlaamsGewest);
    const loader = new Loader({
      apiKey: "AIzaSyC0bp0ut7w4xZvNJlVCOlBJ9VuRNM5jApY",
      version: "weekly",
    });

    loader.load().then(() => {
        this.map = new google.maps.Map(document.getElementById("custom__map"), {
          center: {lat: 50.7039, lng: 4.5699},
          zoom: 8,
          mapTypeId: 'terrain',
          streetViewControl: false,
        });
        this.map.addListener("zoom_changed", () => {
            //this.drawInitialSectors(placedSectors);
        });
        this.map.addListener('tilesloaded', () => {
          this.drawInitialSectors();
        });
        this.map.addListener('dragend', () => {
           this.drawInitialSectors();
        });
      });
  },
  watch: {
    validationSecond(value){
       if(value === "hold" && this.allocatedSearchObjects.length == 0){
        this.inputCheckEmpty = false;
      }
    },
     weightValidity(value){
      this.weightValidationFirst = value;
    },
    weightFromFirst(value){
      this.weight = value;
      if(this.weightSet == true){
        this.allocatedSearchObjects = {'Vlaams Gewest':[],'Brussel Hoofdstedelijk Gewest':[],'Région Wallonne':[]};
        this.totalBoxesFr = 0;
        this.totalBoxesNl = 0;
        this.totalBoxesNlFr = 0;
        this.totalBoxesDuFr = 0;
        this.totalBoxesBil = 0;
        this.totalGrossBoxes = 0;
        this.totalNetBoxes = 0;
        this.arrPlacedSectors = [];
        this.eraseSectorsAfterSwitch(this.allSectors);
        this.totalPrice = 0;
        this.allSectors = [];
      }
      if(this.weightValidationFirst == 'valid'){
        this.weightSet = true;
      }
    },
    yearFromFirst(value){
      this.year = value;
    },
    weekFromFirst(value){
      this.week = value;
      if(this.weekSet == true){
        this.allocatedSearchObjects = {'Vlaams Gewest':[],'Brussel Hoofdstedelijk Gewest':[],'Région Wallonne':[]};
        this.totalBoxesFr = 0;
        this.totalBoxesNl = 0;
        this.totalBoxesNlFr = 0;
        this.totalBoxesDuFr = 0;
        this.totalBoxesBil = 0;
        this.totalGrossBoxes = 0;
        this.totalNetBoxes = 0;
        this.arrPlacedSectors = [];
        this.eraseSectorsAfterSwitch(this.allSectors);
        this.totalPrice = 0;
        this.allSectors = [];
      }
      this.weekSet = true;
    },
    inputCheckEmptyFirst(value){
      this.inputCheck = value;
      /*if(this.inputCheckEmpty == false){
        this.inputCheck = false;
      }*/
    },
    validationFirst(value){
      if(value == 'valid'){
        this.legendStatus = true;
      }else{
         this.legendStatus = false;
      }
    },
    pickerStatus(){
      this.distributionMessageUnique = [];
      this.sectorTypesUnique = [];
    }
  },
  methods: {
    composeDistributionMessage(sectorWeek,sectorType){
      // sectorWeek is the distribution sector type that is availabe in the given week
      // sectorType is the distribution sector type of this sector
      this.distributionMessage = "";
      const allElementsPresent = sectorType.every(element => sectorWeek.includes(element));
      if (allElementsPresent) { // beide array's komen overeen
          if (sectorType.includes('X') && sectorType.length == 1) {
            this.distributionMessage = this.$t("form.secondFieldset.distriMessage2");
          }else if(sectorType.includes('X') && sectorType.length >= 1){
             this.distributionMessage = this.$t("form.secondFieldset.distriMessage4");
          }
      } else { // beide array's komen NIET overeen
        if(sectorType.includes('X') && sectorType.length == 1){
          this.distributionMessage = this.$t("form.secondFieldset.distriMessage2");
        }else if(sectorType.includes('A') && sectorType.includes('X') && sectorType.length == 2){
           this.distributionMessage = this.$t("form.secondFieldset.distriMessage3");
        }else if(sectorType.includes('B') && sectorType.includes('X') && sectorType.length == 2){
           this.distributionMessage = this.$t("form.secondFieldset.distriMessage4");
        }else if(sectorType.includes('B') && sectorType.includes('X') && sectorType.includes('A') && sectorType.length == 3){
          this.distributionMessage = this.$t("form.secondFieldset.distriMessage4");
        }else if(sectorType.includes('A') && sectorType.includes('B') && sectorType.length == 2){
          this.distributionMessage = this.$t("form.secondFieldset.distriMessage1");
        }else if(sectorType.includes('B') || sectorType.includes('A') && sectorType.length == 1){
          this.distributionMessage = this.$t("form.secondFieldset.distriMessage1");
        }
      }
    },
    eraseSectorTypeMessage(districtNumberA,districtNumberB,districtNumberX,sectorType){

        var indexToRemove = "";
        var indexToRemoveSector = "";
        if(districtNumberA !== null){
          //this.distributionMessageArr.push(element.distribution_code_A);
          indexToRemove = this.distributionMessageArr.indexOf(districtNumberA);
        }
        if(districtNumberB !== null){
          //this.distributionMessageArr.push(element.distribution_code_B);
          indexToRemove = this.distributionMessageArr.indexOf(districtNumberB);
        }
        if(districtNumberX!== null){
          //this.distributionMessageArr.push(element.distribution_code_X);
          indexToRemove = this.distributionMessageArr.indexOf(districtNumberX);
        }
        if (indexToRemove !== -1) {
          this.distributionMessageArr.splice(indexToRemove, 1);
        }
        this.distributionMessageUnique = [...new Set(this.distributionMessageArr)]; // make unique array
        indexToRemoveSector = this.sectorTypesArr.indexOf(sectorType);
        if (indexToRemoveSector !== -1) {
          this.sectorTypesArr.splice(indexToRemoveSector, 1);
        }
        this.sectorTypesUnique = [...new Set(this.sectorTypesArr)];
        this.composeDistributionMessage(this.distributionMessageUnique,this.sectorTypesUnique);
    },
     addSectorTypeMessage(districtNumberA,districtNumberB,districtNumberX,sectorType){
        if(districtNumberA !== null){
          //this.distributionMessageArr.push(element.distribution_code_A);
          this.distributionMessageArr.push(districtNumberA);
        }
        if(districtNumberB !== null){
          //this.distributionMessageArr.push(element.distribution_code_B);
          this.distributionMessageArr.push(districtNumberB);
        }
        if(districtNumberX!== null){
          //this.distributionMessageArr.push(element.distribution_code_X);
          this.distributionMessageArr.push(districtNumberX);
        }
        this.distributionMessageUnique = [...new Set(this.distributionMessageArr)]; // make unique array
        this.sectorTypesArr.push(sectorType);
        this.sectorTypesUnique = [...new Set(this.sectorTypesArr)]; // make unique array
        this.composeDistributionMessage(this.distributionMessageUnique,this.sectorTypesUnique);
    },
    checkOnType(type,distriA,distriB){
      var status = "";
      if(type == distriA || type == distriB){
        status = true;
      } else{
        status = false;
      }
      return status;
    },
    openLegend(){
      this.legendStatus = !this.legendStatus;
    },
    scrollToElement(id){
      var element = document.querySelector(id);
      element.scrollIntoView({ behavior: 'smooth', block: 'end'});
    },
    getNumbersGewest(input){
      let output = 0;
      let date = new Date();
      let startDateWeek = new Date(date.getFullYear(), 0, 1);
      let days = Math.floor((date - startDateWeek) /(24 * 60 * 60 * 1000));
      let weekNumber = Math.ceil(days / 7);
      let acutualYear = date.getFullYear();
      let startDate = this.getDateOfISOWeek(weekNumber,acutualYear);
      var host = 'https://'+window.location.host+'/';
      axios.get(host+'boxes-gewesten?input='+input+'&date='+startDate)
        .then(response => {
          //console.log(response.data);
         output = response.data;
          switch (input) {
            case 'Vlaams Gewest':
             this.boxesVlaamsGewest = response.data;
              break;
            case 'Brussel Hoofdstedelijk Gewest':
              this.boxesBxl = response.data;
              break;
            case 'Région Wallonne':
              this.boxesWallone = response.data;
              break;
          }
         return output;
        })
        .catch((error) =>{
          console.log(error);
        })
    },
    getDateOfISOWeek(w, y) {
      //create MYSQL datetime
      var simple = new Date(y, 0, 1 + (w - 1) * 7);
      var dow = simple.getDay();
      var ISOweekStart = simple;
      let startDate = "";
      if (dow <= 4){
          ISOweekStart.setDate(simple.getDate() - simple.getDay() + 2);
      }else{
          ISOweekStart.setDate(simple.getDate() + 9 - simple.getDay());
      }
      startDate = new Date(ISOweekStart);
      startDate = startDate.toISOString().split('T')[0]+ ' ' + startDate.toTimeString().split(' ')[0];
      return startDate;
    },
    calculatePrice(){
      let startDate = this.getDateOfISOWeek(this.week,this.year);
      let weightTier = "";
      //let price = 0;
      //this.weight = 20;
      if(this.weightValidationFirst == "valid"){
        this.weightCheck = true;
        if(this.weight >= 0 && this.weight <= 20){
          weightTier = "0 - 20 gr";
          //price = 4.88;
        }else if(this.weight >= 21 && this.weight <= 50){
          weightTier = "21 - 50 gr";
          //price = 4.88;
        }else if(this.weight >= 51 && this.weight <= 75){
          weightTier = "51 - 75 gr";
          //price = 16.86;
        }else if(this.weight >= 76 && this.weight <= 100){
          weightTier = "76 - 100 gr";
          //price = 52.30;
        }else if(this.weight >= 101 && this.weight <= 150){
          weightTier = "101 - 150 gr";
          //price = 96.36;
        }else if(this.weight >= 151 && this.weight <= 200){
          weightTier = "151 - 200 gr";
          //price = 178.16;
        }else if(this.weight >= 201 && this.weight <= 250){
          weightTier = "201 - 250 gr";
          //price = 340.03;
        }

        var host = 'https://'+window.location.host+'/';
            axios.get(host+'check-price?startdate='+startDate+'&weightTier='+weightTier)
            .then(response => {
              if(response.data.length > 0){
                var totalPrice = 0;
                var totalPriceBase = 0;
                let permanentie = 0;
                var basePrice = 0;
                var fuelPrice = 0;
                var kmPrice = 0;
                response.data.forEach((el) => {
                  if(el.itemId == 'Folder Be Web' && el.weightTier == weightTier){
                    let priceUnit = el.priceUnit; //vb.1000
                    basePrice = el.amount/priceUnit; //vb. 67.74/1000
                    //base
                    totalPrice = basePrice * this.totalGrossBoxes;
                    totalPriceBase = totalPrice;
                  }else if(el.itemId == 'Kilometerheffing'){
                    kmPrice = el.amount/el.priceUnit * this.totalNetBoxes;
                  }else if(el.itemId == 'Brandstoftoeslag'){
                    fuelPrice = el.amount/el.priceUnit * this.totalNetBoxes;
                  }else if(el.itemId == "Permanentietoeslag"){
                    let priceUnit = el.priceUnit; //vb.1000
                    permanentie = totalPrice * el.amount/priceUnit;
                  }

                });

                 totalPrice = totalPriceBase + permanentie + kmPrice + fuelPrice;
                this.totalPrice = totalPrice.toFixed(2);
              }
            })
            .catch((error) =>{
               this.showSuggestions = false;
              console.log(error);
            })
        }else{
          this.$emit('weightCheck', this.weightCheck);
        }
    },
    toggleStatus(arr,type){
      //type.status = !type.status;
      if(type == "province" && arr.checked == true){
        arr.status = !arr.status;
        Object.values(arr.municipalities).forEach((sub) => {
          if(arr.status == false){
            sub.status = false;
          }
        });
      }
      if(type == "municipality"){
        arr.status = !arr.status;
        Object.values(arr.submunicipalities).forEach((sub) => {
          if(arr.status == false){
            sub.status = false;
          }
        });
      }
      if(type == "submunicipality"){
        arr.status = !arr.status;
        Object.values(arr.sectoren).forEach((sub) => {
          sub.status = !sub.status;
        });
      }
    },
    drawInitialSectors(){
        let bounds = this.map.getBounds();
        let zoomlevel = this.map.getZoom();
        let startDate = this.getDateOfISOWeek(this.week,this.year);
         if(zoomlevel >= 12){
          this.mapState = "loading";
           let firstKey = Object.values(bounds)[1];
           let secondKey = Object.values(bounds)[0];
           let latHi = firstKey.hi + 0.035;
           let latLo = firstKey.lo - 0.035;
           let longHi = secondKey.hi + 0.035;
           let longLo = secondKey.lo - 0.035;
           var host =  'https://'+window.location.host+'/';
            axios.get(host+'pan-geo?latHi='+latHi+'&latLo='+latLo+'&longHi='+longHi+'&longLo='+longLo+'&date='+startDate)
            .then(resp => {
              if(resp.data.length > 0){
                //check if new results or not
                if(this.mapLength !== resp.data.length){
                  this.mapState = "loading";
                }else{
                  this.mapState = "empty";
                }
                this.mapLength = resp.data.length;
                resp.data.forEach((el, key) => {
                  let sectorId = el.sector_id;
                  if(Object.prototype.hasOwnProperty.call(this.polygones,sectorId) == false){
                    let geo = el.geodata;
                    var polygon_coords = [];
                    geo = geo.substring(1, geo.length - 1);
                    geo = geo.split("],[");
                    for (var i = 0; i < geo.length; i++) {
                        polygon_coords.push({ // create a google.maps.LatLngLiteral
                          // assume original data is (lat, lng)
                          lng: parseFloat(geo[i].split(',')[0]),
                          lat: parseFloat(geo[i].split(',')[1]),
                        })
                      }
                    let sector = 'sector'+key;
                    sector = new google.maps.Polygon({
                      paths: polygon_coords,
                      strokeColor: "#7AC323",
                      strokeOpacity: 0.7,
                      strokeWeight: 2,
                      fillColor: "#7AC323",
                      fillOpacity: 0,
                      checked: true,
                      sectorId: sectorId
                    });

                    if (!this.polygones[sectorId]){
                      this.polygones[sectorId] = sector;
                    }

                    //get center
                    sector.setMap(this.map);
                    sector.addListener("click", () => {
                      let allSectorIds = [];
                      var checked = sector.checked;
                      if(this.weightValidationFirst == "valid"){
                        if(sector.checked == true){
                          this.searchAdd('draw-on-pan','',el.gewest,el.province,el.municipality,el.sub_municipality,el.sector_id,checked,el.netNumberOfBoxes,el.grossNumberOfBoxes,'');
                          if(!allSectorIds["sectoren"]){
                            allSectorIds["sectoren"] = [el];
                          }
                          sector.setOptions({checked: false});
                        }else if(sector.checked == false){
                          this.searchAdd('draw-on-pan','',el.gewest,el.province,el.municipality,el.sub_municipality,el.sector_id,checked,el.netNumberOfBoxes,el.grossNumberOfBoxes,'');
                          sector.setOptions({checked: true});
                          //toggleChecked()
                        }
                      }else{
                        this.weightCheck = false;
                         this.$emit('weightCheck', this.weightCheck);
                      }
                    });
                    sector.addListener("mouseover",() => {
                      if(sector.checked == true){
                        sector.setOptions({fillOpacity: .35});
                      }
                    });
                    sector.addListener("mouseout",() => {
                      if(sector.checked == true){
                        sector.setOptions({fillOpacity: 0});
                      }
                    });
                  }
                  //console.log(this.polygones);
                });
                this.mapState = "empty";
              }
            })
            .catch((error) =>{
               this.showSuggestions = false;
                console.log(error);
                console.log("Issue with sector call!");
               this.mapState = "empty";
            });
          }
        },
    addSector(locations){
      //this.mapState = "loading";
      locations.forEach((el, key) => {
          var sectorId = key;
          let geo = el.geodata;
          var sectorStatus = el.sectorStatus;
          var polygon_coords = [];
        if(Object.prototype.hasOwnProperty.call(this.polygones,sectorId) == false){
            geo = geo.substring(1, geo.length - 1);
            geo = geo.split("],[");
            for (var i = 0; i < geo.length; i++) {
                polygon_coords.push({ // create a google.maps.LatLngLiteral
                  lng: parseFloat(geo[i].split(',')[0]),
                  lat: parseFloat(geo[i].split(',')[1]),
                })
              }
            let sector = 'sector'+key;
            if(sectorStatus == true){
              sector = new google.maps.Polygon({
                paths: polygon_coords,
                strokeColor: "#7AC323",
                strokeOpacity: 0.7,
                strokeWeight: 2,
                fillColor: "#7AC323",
                fillOpacity: 0.35,
                checked: false,
                sector: sectorId
              });
            }else{
              sector = new google.maps.Polygon({
                paths: polygon_coords,
                strokeColor: "#7AC323",
                strokeOpacity: 0.7,
                strokeWeight: 2,
                fillColor: "#BDC8B6",
                fillOpacity: 0.8,
                checked: false,
                sector: sectorId
              });
            }

            if (!this.polygones[sectorId]){
              this.polygones[sectorId] = sector;
            }
            var paths = sector.getPaths();
            var bounds = new google.maps.LatLngBounds();
            var path;
            for (var p = 0; p < paths.getLength(); p++) {
              path = paths.getAt(p);
              for (var ips = 0; ips < path.getLength(); ips++) {
                bounds.extend(path.getAt(ips));
              }
            }
          //get center
          var center = bounds.getCenter();
          sector.setMap(this.map);
          this.map.setZoom(12);
          this.map.setCenter(center);

          sector.addListener("click", () => {
            let allSectorIds = [];
            var checked = sector.checked;
            if(sector.checked == true){
                       // this.searchOnSector('','sectoren',el.gewest,el.province,el.municipality,el.sub_municipality,el.sector_id,checked,el.netNumberOfBoxes,el.grossNumberOfBoxes);
              this.searchAdd('draw-on-pan','',el.gewest,el.province,el.municipality,el.sub_municipality,el.sector_id,checked,el.netNumberOfBoxes,el.grossNumberOfBoxes,'');
              if(!allSectorIds["sectoren"]){
                  allSectorIds["sectoren"] = [el];
              }
              sector.setOptions({checked: false});
            }else if(sector.checked == false){
              this.searchAdd('draw-on-pan','',el.gewest,el.province,el.municipality,el.sub_municipality,el.sector_id,checked,el.netNumberOfBoxes,el.grossNumberOfBoxes,'');
              sector.setOptions({checked: true});
                        //toggleChecked()
              }
          });
         // }
        }else{
           if(sectorStatus == true){
            this.polygones[sectorId].setOptions({strokeOpacity: .7,fillOpacity: .35,checked: false});
           }else{
            this.polygones[sectorId].setOptions({strokeOpacity: .7,fillOpacity: .8,fillColor: "#BDC8B6",checked: false});
           }
            let paths = this.polygones[sectorId].getPaths();
            let bounds = new google.maps.LatLngBounds();
            let path;
            for (let p = 0; p < paths.getLength(); p++) {
              path = paths.getAt(p);
              for (let ips = 0; ips < path.getLength(); ips++) {
                bounds.extend(path.getAt(ips));
              }
            }
             let center = bounds.getCenter();
            this.map.setCenter(center);
          //this.map.setCenter(center);
        }
        });
      this.mapState = "empty";
    },
    toggleSectors(status,sectoren,sectorStatus){
      sectoren.sectoren.forEach((el) => {
       // console.log(el);
        let sectorId = el.sector_id;
        if(status == false){
           this.polygones[sectorId].setOptions({strokeOpacity: .7,fillOpacity: 0,checked: true});
        }else{
          if(sectorStatus == false){
            this.polygones[sectorId].setOptions({strokeOpacity: .7,fillOpacity: .8,fillColor: "#BDC8B6",checked: false});
          }
          if(sectorStatus == true){
            //console.log("wij komùen in true niet false");
            //console.log(sectorStatus);
            this.polygones[sectorId].setOptions({strokeOpacity: .7,fillOpacity: .35,checked: false});
          }
        }
        this.mapState = "empty";
      });
    },
    eraseSectors(sectoren){
       sectoren.sectoren.forEach((el) => {
        let sectorId = el.sector_id;
        if( el.checked == true){
           this.polygones[sectorId].setOptions({strokeOpacity: .7,fillOpacity: 0,checked: true});
        }
      });
      this.mapState = "empty";
    },
    eraseSectorsAfterSwitch(sectoren){
       sectoren.forEach((el) => {
        let sectorId = el;
        this.polygones[sectorId].setOptions({strokeOpacity: .7,fillOpacity: 0,checked: true});
      });
      this.mapState = "empty";
    },
    searchSuggestion(){
      // when you start typing in the search input field.
      if(this.searchInputWithLabel){
        var char = this.searchInputWithLabel.length;
        let startDate = this.getDateOfISOWeek(this.week,this.year);
        this.suggestionAdded = false;
        this.showSuggestions = false;
        this.selectedPostalCode = "";
        var host = 'https://'+window.location.host+'/';
        if(char >= 4){
          axios.get(host+'search-suggestion?input='+this.searchInputWithLabel+'&date='+startDate)
          .then(response => {
            this.showSuggestions = true;
            this.suggestionResult = response.data;
          })
          .catch((error) =>{
             this.showSuggestions = false;
            console.log(error);
          })
        }
      }
    },
    addSubmunicipality(){

      //this.muniArray[province][muni][submuni].push(sectorStatus);
      //this.makeSubMuniUnique(province,muni,submuni);
    },
    createStatus(prov,muni,submuni,sectorStatus){
       if (!this.statusArr[prov]) {
        // If the key doesn't exist, initialize it with an empty array
            this.statusArr[prov] = [];
          }
           if (!this.statusArr[prov]["status"]) {
        // If the key doesn't exist, initialize it with an empty array
            this.statusArr[prov]["status"] = '';
          }
          if (!this.statusArr[prov][muni]) {
        // If the key doesn't exist, initialize it with an empty array
            this.statusArr[prov][muni] = [];
          }
           if (!this.statusArr[prov][muni]["status"]) {
        // If the key doesn't exist, initialize it with an empty array
            this.statusArr[prov][muni]["status"] = '';
          }
          if (!this.statusArr[prov][muni][submuni]) {
        // If the key doesn't exist, initialize it with an empty array
            this.statusArr[prov][muni][submuni] = [];
          }
          if (!this.statusArr[prov][muni][submuni]["status"]) {
        // If the key doesn't exist, initialize it with an empty array
            this.statusArr[prov][muni][submuni]["status"] = '';
          }
          this.statusArr[prov].push(sectorStatus);
          this.statusArr[prov][muni].push(sectorStatus);
          this.statusArr[prov][muni][submuni].push(sectorStatus);
          var provStatus = this.simplifyStatus("add",this.statusArr[prov]);
          var muniStatus = this.simplifyStatus("add",this.statusArr[prov][muni]);
          var submuniStatus = this.simplifyStatus("add",this.statusArr[prov][muni][submuni]);
          this.statusArr[prov]['status'] = provStatus;
          this.statusArr[prov][muni]['status'] = muniStatus;
          this.statusArr[prov][muni][submuni]['status'] = submuniStatus;
    },
    deleteStatus(prov,muni,submuni,sectorStatus){
     // delete this.provinceArray[prov][element];
      var indexProv = this.statusArr[prov].indexOf(sectorStatus);
      if (indexProv !== -1) {
          this.statusArr[prov].splice(indexProv, 1);
      }

      var indexMuni = this.statusArr[prov][muni].indexOf(sectorStatus);

      if (indexMuni !== -1) {
          this.statusArr[prov][muni].splice(indexMuni, 1);
      }

      var indexSubmuni = this.statusArr[prov][muni][submuni].indexOf(sectorStatus);
      if (indexSubmuni !== -1) {
        this.statusArr[prov][muni][submuni].splice(indexSubmuni, 1);
      }

      var provStatus = this.simplifyStatus("delete",this.statusArr[prov]);
      var muniStatus = this.simplifyStatus("delete",this.statusArr[prov][muni]);
      var submuniStatus = this.simplifyStatus("delete",this.statusArr[prov][muni][submuni]);
      this.statusArr[prov]['status'] = provStatus;
      this.statusArr[prov][muni]['status'] = muniStatus;
      this.statusArr[prov][muni][submuni]['status'] = submuniStatus;
      //this.createStatus(prov,muni,submuni,sectorStatus);
    },
    simplifyStatus(mode,arr){
      var status = "";
      if(mode == "add"){
        if (arr.includes(false)) {
           status = false;
        } else {
          status = true;
        }
      }else{
        if(arr.includes(false) && arr.length == 1){
          status = '';
        }else if(arr.includes(false)){
          status = false;
        }else {
          status = true;
        }
      }
      //console.log("de status is "+status);
      return status;
    },
    checkStatusSubMunicipality(data){
       data.forEach((el) => {
        if (!this.subMuniArray[el.province]) {
        // If the key doesn't exist, initialize it with an empty array
            this.subMuniArray[el.province] = [];
          }
          if (!this.subMuniArray[el.province][el.municipality]) {
        // If the key doesn't exist, initialize it with an empty array
            this.subMuniArray[el.province][el.municipality] = [];
          }
          if (!this.subMuniArray[el.province][el.municipality][el.sub_municipality]) {
        // If the key doesn't exist, initialize it with an empty array
            this.subMuniArray[el.province][el.municipality][el.sub_municipality] = [];
          }
          var status = this.checkOnType(el.sectorType,el.distribution_code_A,el.distribution_code_B);
          this.subMuniArray[el.province][el.municipality][el.sub_municipality].push(status);
          this.makeSubMuniUnique(el.province,el.municipality,el.sub_municipality);
       })
    },
    checkStatusMunicipality(province,el,sectorStatus){
    /* console.log('here');
      console.log(province);
        console.log(el);
        console.log(sectorStatus);*/
      if (!this.muniArray[province]) {
    // If the key doesn't exist, initialize it with an empty array
        this.muniArray[province] = [];
      }
      if (!this.muniArray[province][el]) {
    // If the key doesn't exist, initialize it with an empty array
        this.muniArray[province][el] = [];
      }
      if (!this.provinceArray[province]) {
    // If the key doesn't exist, initialize it with an empty array
        this.provinceArray[province] = [];
      }
      if (!this.provinceArray[province][el]) {
    // If the key doesn't exist, initialize it with an empty array
        this.provinceArray[province][el] = [];
      }

      this.muniArray[province][el].push(sectorStatus);
      this.provinceArray[province][el].push(sectorStatus);
      //var output = '';
      //console.log("this is the muni array before unique");
      //console.log( this.muniArray);
      this.makeStatusUnique(province,el);
      //console.log('dit is de unique status voor de munni');
      //console.log(this.muniStatus[province][el]);

      return this.muniStatus[province][el];
      //return this.muniStatus[el];
    },
    makeSubMuniUnique(province,el,submuni){
       if (!this.subMuniStatus[province]) {
    // If the key doesn't exist, initialize it with an empty array
        this.subMuniStatus[province] = [];
      }
      if (!this.subMuniStatus[province][el]) {
    // If the key doesn't exist, initialize it with an empty array
        this.subMuniStatus[province][el] = [];
      }
      if (!this.subMuniStatus[province][el][submuni]) {
    // If the key doesn't exist, initialize it with an empty array
        this.subMuniStatus[province][el][submuni] = [];
      }
      if(this.subMuniArray[province][el][submuni].includes(false)){
         this.subMuniStatus[province][el][submuni] = false;
      }else{
        this.subMuniStatus[province][el][submuni] = true;
      }
    },
    makeStatusUnique(province,el){
       if (!this.muniStatus[province]) {
    // If the key doesn't exist, initialize it with an empty array
        this.muniStatus[province] = [];
      }
      if (!this.muniStatus[province][el]) {
    // If the key doesn't exist, initialize it with an empty array
        this.muniStatus[province][el] = [];
      }
      if(this.muniArray[province][el].includes(false)){
         this.muniStatus[province][el] = false;
      }else{
        this.muniStatus[province][el] = true;
      }
      this.makeProvinceStatusUnique(province,el);
    },
     makeProvinceStatusUnique(province,el){
      //console.log("province array");
     //console.log(this.provinceArray);
      if (!this.provinceStatus[province]) {
    // If the key doesn't exist, initialize it with an empty array
        this.provinceStatus[province] = [];
      }
      if(this.provinceArray[province][el].includes(false)){
         this.provinceStatus[province][el] = false;
      }else{
        this.provinceStatus[province][el] = true;
      }
      //console.log(this.provinceStatus);
    },
    deleteStatusMunicipality(province,el,sectorStatus){
      var element = el.municipality;
      var prov = province.info;
      //console.log("de province is");
     //console.log(prov);
      //console.log(element);
     // console.log(sectorStatus);
      let indexToRemove = this.muniArray[prov][element].indexOf(sectorStatus);
      let indexProvToRemove = this.provinceArray[prov][element];
     //99* console.log("dit is de index");
      //console.log(indexProvToRemove);
        // Check if the value is found before removing
      if (indexToRemove !== -1) {
           // Remove the value using splice
          this.muniArray[prov][element].splice(indexToRemove, 1);
      }
      if (indexProvToRemove !== -1) {
           // Remove the value using splice
       // console.log('komen wij in delete?');
            delete this.provinceArray[prov][element];
      }
     /* for (let i = 0; i < this.provinceStatus.length; i++) {
            console.log(`Index ${i}: ${this.provinceStatus[i]}`);
        }*/
      //console.log("dit is de array met verwijderd element");
      //console.log(this.provinceArray);
      //this.makeStatusUnique(prov,element);
    },
 /*   deleteStatusMunicipality(province,el,sectorStatus){
      var element = el.municipality;
      var province = province.info;
      let indexToRemove = this.muniArray[element].indexOf(sectorStatus);
        // Check if the value is found before removing
      if (indexToRemove !== -1) {
           // Remove the value using splice
          this.muniArray[element].splice(indexToRemove, 1);
      }
      this.makeStatusUnique(element);
    },*/
    searchSingle(value,type,postalcode){
      var obj = {};
      let startDate = this.getDateOfISOWeek(this.week,this.year);
      let host = 'https://'+window.location.host+'/';
      obj = this.allocatedSearchObjects;
      var locations = [];
     // var test = '';
     // var test2 = '';
      this.inputCheck = true;
      if(value != '' && this.weightValidationFirst == 'valid'){
        this.mapState = "loading";
        axios.get(host+'get-single?input='+value+'&type='+type+'&date='+startDate+'&postalcode='+postalcode+'&week='+this.week)
        .then(response => {
          let length = response.data.length;
          if(length > 0){
            //var sectorId = '';
            //this.checkStatusSubMunicipality(element.province,element.municipality,element.sub_municipality,this.sectorStatus);
            //this.checkStatusSubMunicipality(response.data);
            response.data.forEach((element) => {
              if(Object.prototype.hasOwnProperty.call(obj[element.gewest],'checked') == false){
                  obj[element.gewest] = {"checked": true, languageCode: element.languageCode,info:element.gewest};
              }
              this.sectorStatus = this.checkOnType(element.sectorType,element.distribution_code_A,element.distribution_code_B);
              this.createStatus(element.province,element.municipality,element.sub_municipality,this.sectorStatus);
              this.provStatus = this.statusArr[element.province]['status'];
              this.muniStatus = this.statusArr[element.province][element.municipality]['status'];
              this.submuniStatus = this.statusArr[element.province][element.municipality][element.sub_municipality]['status'];
              //test = this.checkStatusMunicipality(element.province,element.municipality,this.sectorStatus);
              //test2 = this.checkStatusSubMunicipality(element.province,element.municipality,element.sub_municipality,this.sectorStatus);
              if (!obj[element.gewest]["provinces"]) {
                obj[element.gewest]["provinces"] = {};
              }
              if (!obj[element.gewest]["provinces"][element.province]) {
                obj[element.gewest]["provinces"][element.province] = {"info":element.province,checked:true,languageCode:element.languageCode,'sectorStatus': this.statusArr[element.province]['status']};
              }
              if(obj[element.gewest]["provinces"][element.province]) {
                obj[element.gewest]["provinces"][element.province].sectorStatus = this.provStatus ;
              }

              if(!obj[element.gewest]["provinces"][element.province]["municipalities"]){
                obj[element.gewest]["provinces"][element.province]["municipalities"] = {};
              }
              if(obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]){
                obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality].sectorStatus = this.muniStatus;
              }
              if(!obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]){
                obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality] = {"municipality":element.municipality,"checked":true,'languageCode':element.languageCode,boxes:'',status:false,"completion":true,'counter':0,'sectorStatus': this.statusArr[element.province][element.municipality]['status']};
              }
              if(!obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities']){
                obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'] = {};
              }
              if(obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality]){
                obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality].sectorStatus =  this.submuniStatus;
              }
              if(!obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality]){
                this.sumMunicipality = this.sumMunicipality + Number(element.netNumberOfBoxes);
                  obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality] = {"info":element.postalcode +' - '+ element.sub_municipality,"originalSubmuni":element.sub_municipality,"checked":true, "boxes": this.sumMunicipality,'languageCode':element.languageCode,"status":false,"completion":true,'counter':1,'sectorStatus':this.statusArr[element.province][element.municipality][element.sub_municipality]['status']};
              }
              if(!obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality]["sectoren"]){
                obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality]["sectoren"] = {};
              }
              if(!obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality]["sectoren"][element.sector_id]){
                //test2 = this.checkStatusSubMunicipality(element.province,element.municipality,element.sub_municipality,this.sectorStatus);
                obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality]["sectoren"][element.sector_id] = {'geodata': element.geodata,'sector_id': element.sector_id,'sector_name': element.sector_name,'grossNumberOfBoxes':element.grossNumberOfBoxes,'proxyGrossNumberOfBoxes':element.grossNumberOfBoxes,'netNumberOfBoxes':element.netNumberOfBoxes,'proxyNetNumberOfBoxes':element.netNumberOfBoxes,'languageCode':element.languageCode,"checked":true,'sectorStatus': this.sectorStatus,'distributionCodeA':element.distribution_code_A,'distributionCodeB':element.distribution_code_B,'distributionCodeX':element.distribution_code_X,'sectorType':element.sectorType};
              }
              this.arrParsed = true;
              // build array for adding polygon
              if(this.arrPlacedSectors.includes(element.sector_id) == false){
                if(element.languageCode == "BIL"){
                    if(this.sectorStatus == true){
                      this.totalBoxesBil = this.totalBoxesBil + Number(element.netNumberOfBoxes);
                    }
                }
                if(element.languageCode == "NL"){
                  if(this.sectorStatus == true){
                    this.totalBoxesNl = this.totalBoxesNl + Number(element.netNumberOfBoxes);
                  }
                }
                if(element.languageCode == "FR"){
                  if(this.sectorStatus == true){
                    this.totalBoxesFr = this.totalBoxesFr + Number(element.netNumberOfBoxes);
                  }
                }
                if(element.languageCode == "NL & FR"){
                  if(this.sectorStatus == true){
                    this.totalBoxesNlFr = this.totalBoxesNlFr + Number(element.netNumberOfBoxes);
                  }
                }
                if(element.languageCode == "FR & DE"){
                  if(this.sectorStatus == true){
                    this.totalBoxesDuFr = this.totalBoxesDuFr + Number(element.netNumberOfBoxes);
                  }
                }
                if(this.sectorStatus == true){
                  this.totalGrossBoxes = this.totalGrossBoxes + Number(element.grossNumberOfBoxes);
                }

                //this.arrPlacedSectors.push(element.sector_id);
                this.arrPlacedSectors[element.sector_id] = element.sector_id;
                element['sectorStatus'] = this.sectorStatus;
                locations[element.sector_id] = element;

              }
              if(this.sectorStatus == true){
                this.totalNetBoxes = this.totalBoxesNl + this.totalBoxesFr + this.totalBoxesBil + this.totalBoxesNlFr + this.totalBoxesDuFr;
              }
              this.allocatedSearchObjects = obj;
              if(!this.allSectors.includes(element.sector_id)){
                this.allSectors.push(element.sector_id);
              }
              if(element.distribution_code_A !== null){
                 this.distributionMessageArr.push(element.distribution_code_A);
              }
              if(element.distribution_code_B !== null){
                 this.distributionMessageArr.push(element.distribution_code_B);
              }
              if(element.distribution_code_X !== null){
                 this.distributionMessageArr.push(element.distribution_code_X);
              }
              this.distributionMessageUnique = [...new Set(this.distributionMessageArr)]; // make unique array
              this.sectorTypesArr.push(element.sectorType);
              this.sectorTypesUnique = [...new Set(this.sectorTypesArr)]; // make unique array
            });
            this.addSector(locations,'');
            this.searchInputWithLabel = "";
            this.searchInput = "";
            this.sendValues();
            this.calculatePrice();
            this.composeDistributionMessage(this.distributionMessageUnique,this.sectorTypesUnique);
          }
        })
        .catch((error) =>{
          console.log(error);
        });
      }else if(value == ""){
        this.inputCheck = false;
        this.showSuggestions = false;
      }else if(this.weightValidity == "invalid" || this.weight == 0){
        this.weightCheck = false;
        this.showSuggestions = false;
        this.$emit('weightCheck', this.weightCheck);
        this.scrollToElement("#prijscalc-gewicht");
      }else{
        this.showSuggestions = false;
      }
    },
    activateSuggestions(){
      if(this.suggestionResult.length > 0){
        this.showSuggestions = true;
      }
    },
    addToSearchInput(value,type,key,postalCode){
      let lang = document.documentElement.lang;
      this.searchInput = "";
      if(lang == 'nl'){
        switch (type) {
          case 'province':
            this.suggestionLabel = "Provincie";
          break;
          case 'municipality':
            this.suggestionLabel = "Gemeente";
          break;
          case 'sub_municipality':
            this.suggestionLabel = "Deelgemeente";
            if(postalCode != ""){
              this.selectedPostalCode = postalCode;
            }
          break;

        }
      }else{
        switch (type) {
          case 'province':
            this.suggestionLabel = "Province";
          break;
          case 'municipality':
            this.suggestionLabel = "Commune";
          break;
          case 'sub_municipality':
            this.suggestionLabel = "Sous-municipalité";
            if(postalCode != ""){
              this.selectedPostalCode = postalCode;
            }
          break;
        }
      }
      this.searchInputWithLabel =  this.suggestionLabel+": "+value;
      this.searchInput = key;
      this.suggestionType = type;
      this.inputCheck = true;
      // when you click on a value in search suggestion.

      this.showSuggestions = false;
    },
    getProvinces(input,gewestStatus){
      var obj = this.allocatedSearchObjects;
      this.flowCheck = "province";
      let startDate = this.getDateOfISOWeek(this.week,this.year);
      let host = 'https://'+window.location.host+'/';
      if(gewestStatus == true){
        axios.get(host+'get-provinces?input='+input+'&date='+startDate+'&week='+this.week)
          .then(response => {
            let length = response.data.length;
            if(length > 0){
              response.data.forEach((element) => {
                 if (!this.statusArr[element.province]) {
                 // If the key doesn't exist, initialize it with an empty array
                  this.statusArr[element.province] = [];
                }
                 if (!this.statusArr[element.province]["status"]) {
              // If the key doesn't exist, initialize it with an empty array
                  this.statusArr[element.province]["status"] = '';
                }

                //this.provStatus = this.statusArr[element.province]['status'];
                 if (!obj[element.gewest]){
                  obj[element.gewest] = {checked: true, languageCode: element.languageCode};
                }
                if (!obj[element.gewest]["provinces"]) {
                  obj[element.gewest]["provinces"] = {};
                }
                if (!obj[element.gewest]["provinces"][element.province]) {
                     //obj[element.gewest]["provinces"][element.province] = {"info":element.province,checked:false,languageCode:element.languageCode,loadStatus: false,status: true};
                    obj[element.gewest]["provinces"][element.province] = {"info":element.province,checked:true,languageCode:element.languageCode,sectorStatus: this.statusArr[element.province]['status'],status: true};
                }
              });
            }
          })
          .catch((error) =>{
            this.mapState = "empty";
            console.log(error);
          });
        }
    },
    searchAdd(status,type,gewest,province,municipality,submunicipality,sector_id,checked,boxes,grossBoxes,loadStatus){
      //check if there is a result from searchsuggestion.
      this.sector_id = sector_id;
      let input = '';
      let startDate = this.getDateOfISOWeek(this.week,this.year);
      this.suggestionResult = [];
      var locations = [];
      this.mapState = "loading";
      var obj = this.allocatedSearchObjects;
      let host = 'https://'+window.location.host+'/';
      let path = "";
      //var test = "";
      //var test2 = "";
      if(status == "search"){
        path = "search-geo";
        if(this.suggestionAdded == true){
          //user picked a search suggestion.
          input = this.searchedZipcode;
        }else{
          input = this.searchInput;
          }
        }else if(status == "draw-on-pan"){
            path = "get-geo-from-map";
            input = this.sector_id;
        }else if(status == "get-gewest"){
            path = "get-gewest";
            input = gewest;
        }else if(status == "province"){
            path = "get-municipalities";
            input = province;
      }
      if(status == "search" || status == "draw-on-pan" || (status == "province" && loadStatus == false && checked == true)){
        if(this.weightValidationFirst != '' || this.weightValidationFirst == "valid"){
          axios.get(host+path+'?input='+input+'&date='+startDate+'&week='+this.week)
          .then(response => {
            this.showSuggestions = false;
            this.searchInput = "";
            let length = response.data.length;
            // Get GEO DATA
             if(length > 0){
              //this.checkStatusSubMunicipality(response.data);
              response.data.forEach((element) => {
              // ***********
              this.sectorStatus = this.checkOnType(element.sectorType,element.distribution_code_A,element.distribution_code_B);
             // if(status != "draw-on-pan"){
            if(status == 'draw-on-pan' && checked == true){
                this.createStatus(element.province,element.municipality,element.sub_municipality,this.sectorStatus);
                this.provStatus = this.statusArr[element.province]['status'];
                this.muniStatus = this.statusArr[element.province][element.municipality]['status'];
                this.submuniStatus = this.statusArr[element.province][element.municipality][element.sub_municipality]['status'];
             }
              //console.log(provStatus);
             // console.log(muniStatus);
              //console.log(submuniStatus);
              //test = this.checkStatusMunicipality(element.province,element.municipality,this.sectorStatus);
              //test2 = this.checkStatusProvince(element.province,test);
              //console.log("dit is test 2");
              //console.log(test2);

                if (!obj[element.gewest]){
                  obj[element.gewest] = {checked: true, languageCode: element.languageCode,info: element.gewest};
                }
                if(Object.prototype.hasOwnProperty.call(obj[element.gewest],'checked') == false){
                    obj[element.gewest] = {"checked": true, languageCode: element.languageCode,info: element.gewest};
                }
                if (!obj[element.gewest]["provinces"]) {
                  obj[element.gewest]["provinces"] = {};
                }
                if(obj[element.gewest]["provinces"][element.province]) {
                  obj[element.gewest]["provinces"][element.province].sectorStatus = this.provStatus ;
                }
                if(!obj[element.gewest]["provinces"][element.province]) {
                  obj[element.gewest]["provinces"][element.province] = {"info":element.province,checked:true,languageCode:element.languageCode,'sectorStatus': this.provStatus};
                }
                if(!obj[element.gewest]["provinces"][element.province]["municipalities"]){
                  obj[element.gewest]["provinces"][element.province]["municipalities"] = {};
                }
                if(obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]){
                  obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality].sectorStatus = this.muniStatus;
                }
                if(!obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]){
                  obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality] = {"municipality":element.municipality,"checked":true,'languageCode':element.languageCode,boxes:'',status:false,"completion":true,'counter':0,'sectorStatus': this.muniStatus};
                }
                if(!obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities']){
                  obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'] = {};
                }
                if(obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality]){
                  obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality].sectorStatus =  this.submuniStatus;
                }
                if(!obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality]){
                  this.sumMunicipality = this.sumMunicipality + Number(element.netNumberOfBoxes);
                  obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality] = {"info":element.postalcode +' - '+ element.sub_municipality,"originalSubmuni":element.sub_municipality,"checked":true, "boxes": this.sumMunicipality,'languageCode':element.languageCode,status:false,"completion":true,'counter':0,'sectorStatus': this.submuniStatus};
                }
                if(!obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality]["sectoren"]){
                  obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality]["sectoren"] = {};
                }

                if(!obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality]["sectoren"][element.sector_id]){
                  obj[element.gewest]["provinces"][element.province]["municipalities"][element.municipality]['submunicipalities'][element.sub_municipality]["sectoren"][element.sector_id] = {'geodata': element.geodata,'sector_id': element.sector_id,'sector_name': element.sector_name,'grossNumberOfBoxes':element.grossNumberOfBoxes,'proxyGrossNumberOfBoxes':element.grossNumberOfBoxes,'netNumberOfBoxes':element.netNumberOfBoxes,'proxyNetNumberOfBoxes':element.netNumberOfBoxes,'languageCode':element.languageCode,"checked":true,'sectorStatus': this.sectorStatus,'distributionCodeA':element.distribution_code_A,'distributionCodeB':element.distribution_code_B,'distributionCodeX':element.distribution_code_X,'sectorType':element.sectorType};
                }
                if(status == "search" || status == "province"){
                  this.arrParsed = true;
                // build array for adding polygon
                 if(this.arrPlacedSectors.includes(element.sector_id) == false){
                  if(element.languageCode == "BIL"){
                    if( this.sectorStatus == true){
                      this.totalBoxesBil = this.totalBoxesBil + Number(element.netNumberOfBoxes);
                    }
                  }
                  if(element.languageCode == "NL"){
                    if( this.sectorStatus == true){
                      this.totalBoxesNl = this.totalBoxesNl + Number(element.netNumberOfBoxes);
                    }
                  }
                  if(element.languageCode == "FR"){
                    if(this.sectorStatus == true){
                      this.totalBoxesFr = this.totalBoxesFr + Number(element.netNumberOfBoxes);
                    }
                  }
                  if(element.languageCode == "NL & FR"){
                    if(this.sectorStatus == true){
                      this.totalBoxesNlFr = this.totalBoxesNlFr + Number(element.netNumberOfBoxes);
                    }
                  }
                  if(element.languageCode == "FR & DE"){
                    if(this.sectorStatus == true){
                      this.totalBoxesDuFr = this.totalBoxesDuFr + Number(element.netNumberOfBoxes);
                    }
                  }
                  this.totalGrossBoxes = this.totalGrossBoxes + Number(element.grossNumberOfBoxes);
                  this.arrPlacedSectors[element.sector_id] = element.sector_id;
                  locations[element.sector_id] = element;
                }
                 if(this.sectorStatus == true){
                  this.totalNetBoxes = this.totalBoxesNl + this.totalBoxesFr + this.totalBoxesBil + this.totalBoxesNlFr + this.totalBoxesDuFr;
                 }
                 if(!this.allSectors.includes(element.sector_id)){
                  this.allSectors.push(element.sector_id);
                }
                 this.calculatePrice();
                 //this.composeDistributionMessage(this.distributionMessageUnique,this.sectorTypesUnique);
               }
                this.allocatedSearchObjects = obj;
              });
              if(status == "search"){
               this.addSector(locations,'');
               this.sendValues();
              }else if (status == "province"){
                this.addSector(locations,'province');
                this.provincesLoaded = true;
                this.inputCheck = true;
                let allSectorIds = [];
                if(!allSectorIds["sectoren"]){
                  allSectorIds["sectoren"] = [];
                }
              }else if (status == "draw-on-pan"){
                let allSectorIds = [];
                if(!allSectorIds["sectoren"]){
                  allSectorIds["sectoren"] = [response.data[0]];
                  allSectorIds["sectorStatus"] = this.sectorStatus;
                }
                //this.mapState = "empty";
                let lang =  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['languageCode'];
                let sectorStatus = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].sectorStatus;
                if(checked == false){
                  this.deleteStatus(this.allocatedSearchObjects[gewest]['provinces'][province].info,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].municipality,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].originalSubmuni,sectorStatus);
                  this.eraseSectorTypeMessage(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeA'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeB'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeX'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['sectorType']);
                  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].checked = false;
                  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['netNumberOfBoxes'] = boxes;
                  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['proxyNetNumberOfBoxes'] = 0;
                  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['grossNumberOfBoxes'] = grossBoxes;
                  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['proxyGrossNumberOfBoxes'] = 0;
                  if(sectorStatus == true){
                    if(lang == "NL"){
                     if(this.sectorStatus == true){
                      this.totalBoxesNl = this.totalBoxesNl - Number(boxes);
                     }
                  }
                  if(lang == "FR"){
                    if(this.sectorStatus == true){
                      this.totalBoxesFr = this.totalBoxesFr - Number(boxes);
                    }
                  }
                  if(lang == "BIL"){
                    if(this.sectorStatus == true){
                      this.totalBoxesBil = this.totalBoxesBil - Number(boxes);
                    }
                  }
                  if(lang == "NL & FR"){
                     if(this.sectorStatus == true){
                      this.totalBoxesNlFr = this.totalBoxesNlFr - Number(boxes);
                    }
                  }
                  if(lang == "FR & DE"){
                     if(this.sectorStatus == true){
                      this.totalBoxesDuFr = this.totalBoxesDuFr - Number(boxes);
                     }
                  }
                  this.totalGrossBoxes = this.totalGrossBoxes - Number(grossBoxes);
                  this.totalNetBoxes =  this.totalNetBoxes - Number(boxes);
                }


                this.eraseFromTotals(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].sector_id);
                this.sendValues();
              }
              if(checked == true){
                /*this.createStatus(element.province,element.municipality,element.sub_municipality,this.sectorStatus);*/
               /*this.createStatus(this.allocatedSearchObjects[gewest]['provinces'][province].info,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].municipality,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].originalSubmuni,sectorStatus);*/
               /* this.addSubmunicipality(this.allocatedSearchObjects[gewest]['provinces'][province].info,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].municipality,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].originalSubmuni,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].sectorStatus);*/
               /* this.checkStatusProvince(this.allocatedSearchObjects[gewest]['provinces'][province].info,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].sectorStatus);*/


               this.addSectorTypeMessage(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeA'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeB'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeX'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].sectorType);
                this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].checked = true;
                this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['proxyNetNumberOfBoxes'] = boxes;
                this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['proxyGrossNumberOfBoxes'] = grossBoxes;
                if(sectorStatus == true){
                  if(lang == "NL"){
                    if(this.sectorStatus == true){
                      this.totalBoxesNl = this.totalBoxesNl + Number(boxes);
                    }
                  }
                  if(lang == "FR"){
                    if(this.sectorStatus == true){
                      this.totalBoxesFr = this.totalBoxesFr + Number(boxes);
                    }
                  }
                  if(lang == "BIL"){
                    if(this.sectorStatus == true){
                      this.totalBoxesBil = this.totalBoxesBil + Number(boxes);
                    }
                  }
                  if(lang == "NL & FR"){
                    if(this.sectorStatus == true){
                      this.totalBoxesNlFr = this.totalBoxesNlFr + Number(boxes);
                    }
                  }
                  if(lang == "FR & DE"){
                     if(this.sectorStatus == true){
                        this.totalBoxesDuFr = this.totalBoxesDuFr + Number(boxes);
                      }
                  }
                  this.totalGrossBoxes = this.totalGrossBoxes + Number(grossBoxes);
                  this.totalNetBoxes =  this.totalNetBoxes + Number(boxes);
                }

                if(!this.allSectors.includes(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].sector_id)){
                  this.allSectors.push(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].sector_id);
                }
                this.sendValues();
                //}
              }

              //this.composeDistributionMessage(this.distributionMessageUnique,this.sectorTypesUnique);
              this.calculatePrice();
              if(!allSectorIds["sectoren"]){
                allSectorIds["sectoren"] = [this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]];
              }
              this.toggleSectors(checked, allSectorIds, sectorStatus);

              }
             }
          })
          .catch((error) =>{
            this.mapState = "empty";
            console.log(error);
          });
         }else{
          this.mapState = "empty";
          if(status == 'province'){
            if(this.weightValidationFirst == false){
              this.scrollToElement("#prijscalc_gewicht-wrapper");
            }
          }
         }
      }else{
        if(type == "sectoren"){
          let allSectorIds = [];
          let length =  Object.keys(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren']).length;
          let i = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].counter;
          let lang =  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['languageCode'];
          let sectorStatus = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].sectorStatus;
            if(checked == false){
              this.deleteStatus(this.allocatedSearchObjects[gewest]['provinces'][province].info,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].municipality,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].originalSubmuni,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].sectorStatus);
              this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['netNumberOfBoxes'] = boxes;
              this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['proxyNetNumberOfBoxes'] = 0;
              this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['grossNumberOfBoxes'] = grossBoxes;
              this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['proxyGrossNumberOfBoxes'] = 0;
              if(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['counter'] > 0){
               this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].completion = false;
                this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['counter'] = i + 1;
                if(i == length){
                   this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].completion = true;
                }
              }
              this.eraseSectorTypeMessage(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeA'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeB'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeX'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['sectorType']);
              if(sectorStatus == true){
                 if(lang == "NL"){
                    this.totalBoxesNl = this.totalBoxesNl - Number(boxes);
                 }
                 if(lang == "FR"){
                    this.totalBoxesFr = this.totalBoxesFr - Number(boxes);
                 }
                  if(lang == "BIL"){
                      this.totalBoxesBil = this.totalBoxesBil - Number(boxes);
                 }
                 if(lang == "NL & FR"){
                    this.totalBoxesNlFr = this.totalBoxesNlFr - Number(boxes);
                }
                if(lang == "FR & DE"){
                    this.totalBoxesDuFr = this.totalBoxesDuFr - Number(boxes);

                }
                this.totalGrossBoxes = this.totalGrossBoxes - Number(grossBoxes);
                this.totalNetBoxes =  this.totalNetBoxes - Number(boxes);
               }


               // remove sector ID from total sectors
              let sectorId = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].sector_id;
              this.eraseFromTotals(sectorId);
              this.sendValues();
              this.calculatePrice();
            }
            if(checked == true){
              this.createStatus(this.allocatedSearchObjects[gewest]['provinces'][province].info,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].municipality,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].originalSubmuni,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].sectorStatus);
              this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['proxyNetNumberOfBoxes'] = boxes;
              this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['proxyGrossNumberOfBoxes'] = grossBoxes;
              this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['counter'] = i -1;
              if(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['counter'] == 1){
                  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].completion = true;
              }else{
                this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].completion = false;
              }
              this.addSectorTypeMessage(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeA'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeB'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeX'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['sectorType']);
              if(sectorStatus == true){
                if(lang == "NL"){
                    this.totalBoxesNl = this.totalBoxesNl + Number(boxes);
                }
                if(lang == "FR"){
                    this.totalBoxesFr = this.totalBoxesFr + Number(boxes);
                }
                if(lang == "BIL"){
                    this.totalBoxesBil = this.totalBoxesBil + Number(boxes);
                }
                if(lang == "NL & FR"){
                    this.totalBoxesNlFr = this.totalBoxesNlFr + Number(boxes);
                }
                if(lang == "FR & DE"){
                    this.totalBoxesDuFr = this.totalBoxesDuFr + Number(boxes);
                }
                this.totalGrossBoxes = this.totalGrossBoxes + Number(grossBoxes);
                this.totalNetBoxes =  this.totalNetBoxes + Number(boxes);
              }

              let sectorId = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].sector_id;
              if(!this.allSectors.includes(sectorId)){
                this.allSectors.push(sectorId);
              }
              this.sendValues();
              this.calculatePrice();
            }

            if(!allSectorIds["sectoren"]){
              allSectorIds["sectoren"] = [this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]];
            }
            this.toggleSectors(checked, allSectorIds, sectorStatus);
        }
        if(type == "submuni"){
          let allSectorIds = [];
          if(!allSectorIds["sectoren"]){
            allSectorIds["sectoren"] = [];
          }
          //this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'];
          let lang =  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['languageCode'];
          let arr = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality];
          let length =  Object.keys(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren']).length;
          let lengthMuni =  Object.keys(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities']).length;
          let i = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].counter;
          let sectorStatus = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].sectorStatus;
          if(checked == false){
              if(lengthMuni > 1){
               this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].completion = false;
                  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['counter'] = i + 1;
                if(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].counter == lengthMuni){
                   this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].completion = true;
                }
              }
              Object.values(arr.sectoren).forEach((el) => {
                el.proxyNetNumberOfBoxes = 0;
                el.proxyGrossNumberOfBoxes = 0;
                allSectorIds["sectoren"].push(el);
                this.deleteStatus(this.allocatedSearchObjects[gewest]['provinces'][province].info,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].municipality,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].originalSubmuni,el.sectorStatus);
                this.eraseSectorTypeMessage(el.distributionCodeA,el.distributionCodeB,el.distributionCodeX,el.sectorType);
                if(sectorStatus == true){
                if(lang == "NL"){
                  if(el.checked == false){
                    this.totalBoxesNl = this.totalBoxesNl + Number(el.netNumberOfBoxes);
                  }
                  this.totalBoxesNl = this.totalBoxesNl - Number(el.netNumberOfBoxes);
                 }
                 if(lang == "FR"){
                     if(el.checked == false){
                      this.totalBoxesFr = this.totalBoxesFr + Number(el.netNumberOfBoxes);
                     }
                     this.totalBoxesFr = this.totalBoxesFr - Number(el.netNumberOfBoxes);
                 }
                  if(lang == "BIL"){
                      if(el.checked == false){
                        this.totalBoxesBil = this.totalBoxesBil + Number(el.netNumberOfBoxes);
                      }
                      this.totalBoxesBil = this.totalBoxesBil - Number(el.netNumberOfBoxes);
                 }
                 if(lang == "NL & FR"){
                      if(el.checked == false){
                        this.totalBoxesNlFr = this.totalBoxesNlFr + Number(el.netNumberOfBoxes);
                      }
                      this.totalBoxesNlFr = this.totalBoxesNlFr - Number(el.netNumberOfBoxes);
                  }
                  if(lang == "FR & DE"){
                      if(el.checked == false){
                        this.totalBoxesDuFr = this.totalBoxesDuFr + Number(el.netNumberOfBoxes);
                      }
                      this.totalBoxesDuFr = this.totalBoxesDuFr - Number(el.netNumberOfBoxes);
                  }
                  if(el.checked == false){
                    this.totalGrossBoxes = this.totalGrossBoxes + Number(el.grossNumberOfBoxes);
                    this.totalNetBoxes =  this.totalNetBoxes + Number(el.netNumberOfBoxes);
                  }
                  this.totalGrossBoxes = this.totalGrossBoxes - Number(el.grossNumberOfBoxes);
                 this.totalNetBoxes =  this.totalNetBoxes - Number(el.netNumberOfBoxes);
                }

                  el.checked = false;
                  this.eraseFromTotals(el.sector_id);
                  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].counter = length;
              });
               this.sendValues();
               this.calculatePrice();
           }
          if(checked == true){
              this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['counter'] = i - 1;
              if(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].counter == 0){
                  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].completion = true;
              }else{
                this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].completion = false;
              }
              Object.values(arr.sectoren).forEach((el) => {
                el.proxyNetNumberOfBoxes = el.netNumberOfBoxes;
                el.proxyGrossNumberOfBoxes = el.grossNumberOfBoxes;
                el.checked = true;
                this.createStatus(this.allocatedSearchObjects[gewest]['provinces'][province].info,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].municipality,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].originalSubmuni,el.sectorStatus);
              // this.checkStatusProvince(this.allocatedSearchObjects[gewest]['provinces'][province].info,sectorStatus);
                this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].completion = true;
                allSectorIds["sectoren"].push(el);
                this.addSectorTypeMessage(el.distributionCodeA,el.distributionCodeB,el.distributionCodeX,el.sectorType);
                if(sectorStatus == true){
                  if(lang == "NL"){
                      this.totalBoxesNl = this.totalBoxesNl + Number(el.netNumberOfBoxes);
                    }
                   if(lang == "FR"){
                      this.totalBoxesFr = this.totalBoxesFr + Number(el.netNumberOfBoxes);
                   }
                  if(lang == "BIL"){
                      this.totalBoxesBil = this.totalBoxesBil + Number(el.netNumberOfBoxes);
                  }
                  if(lang == "NL & FR"){
                      this.totalBoxesNlFr = this.totalBoxesNlFr + Number(el.netNumberOfBoxes);
                  }
                  if(lang == "FR & DE"){
                      this.totalBoxesDuFr = this.totalBoxesDuFr + Number(el.netNumberOfBoxes);
                  }
                this.totalGrossBoxes = this.totalGrossBoxes + Number(el.grossNumberOfBoxes);
                 this.totalNetBoxes =  this.totalNetBoxes + Number(el.netNumberOfBoxes);
                }

               if(!this.allSectors.includes(el.sector_id)){
                this.allSectors.push(el.sector_id);
                }
              });
              this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].counter = 0;
              this.sendValues();
              this.calculatePrice();
          }
           this.toggleSectors(checked, allSectorIds, sectorStatus);
        }
        if(type == 'muni'){

          let allSectorIds = [];
          if(!allSectorIds["sectoren"]){
            allSectorIds["sectoren"] = [];
          }
          let lang =  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['languageCode'];
          let arr = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'];
          var sectorStatus = '';

          //let sectorStatus = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].sectorStatus;
         // this.sectorStatus = this.checkOnType(element.sectorType,element.distribution_code_A,element.distribution_code_B);
          //test = this.checkStatusMunicipality(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities']['submunicipalities'],this.sectorStatus);
           if(checked == false){
            Object.values(arr).forEach((val) => {
              Object.values(val.sectoren).forEach((sec) => {
                sec.proxyNetNumberOfBoxes = 0;
                sec.proxyGrossNumberOfBoxes = 0;
                allSectorIds["sectoren"].push(sec);
                sectorStatus = sec.sectorStatus;
                this.deleteStatus(this.allocatedSearchObjects[gewest]['provinces'][province].info,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].municipality,val.originalSubmuni,sectorStatus);
                this.eraseSectorTypeMessage(sec.distributionCodeA,sec.distributionCodeB,sec.distributionCodeX,sec.sectorType);
              if(sec.sectorStatus == true){
                if(lang == "NL"){
                    if(sec.checked == false){
                      this.totalBoxesNl = this.totalBoxesNl + Number(sec.netNumberOfBoxes);
                    }
                    this.totalBoxesNl = this.totalBoxesNl - Number(sec.netNumberOfBoxes);
                 }
               if(lang == "FR"){
                  if(sec.checked == false){
                    this.totalBoxesFr = this.totalBoxesFr + Number(sec.netNumberOfBoxes);
                  }
                  this.totalBoxesFr = this.totalBoxesFr - Number(sec.netNumberOfBoxes);
               }
                if(lang == "BIL"){
                    if(sec.checked == false){
                      this.totalBoxesBil = this.totalBoxesBil + Number(sec.netNumberOfBoxes);
                   }
                   this.totalBoxesBil = this.totalBoxesBil - Number(sec.netNumberOfBoxes);
               }
                if(lang == "NL & FR"){
                    if(sec.checked == false){
                      this.totalBoxesNlFr = this.totalBoxesNlFr + Number(sec.netNumberOfBoxes);
                    }
                     this.totalBoxesNlFr = this.totalBoxesNlFr - Number(sec.netNumberOfBoxes);
                }
                if(lang == "FR & DE"){
                    if(sec.checked == false){
                      this.totalBoxesDuFr = this.totalBoxesDuFr + Number(sec.netNumberOfBoxes);
                    }
                    this.totalBoxesDuFr = this.totalBoxesDuFr - Number(sec.netNumberOfBoxes);
                }
                if(sec.checked == false){
                    this.totalGrossBoxes = this.totalGrossBoxes + Number(sec.grossNumberOfBoxes);
                    this.totalNetBoxes =  this.totalNetBoxes + Number(sec.netNumberOfBoxes);
                }
                this.totalGrossBoxes = this.totalGrossBoxes - Number(sec.grossNumberOfBoxes);
                this.totalNetBoxes =  this.totalNetBoxes - Number(sec.netNumberOfBoxes);
              }


               sec.checked = false;
                this.eraseFromTotals(sec.sector_id);
              });
            });
             this.sendValues();
             this.calculatePrice();
           }
           if(checked == true){
             Object.values(arr).forEach((val) => {
                Object.values(val.sectoren).forEach((sec) => {
                  sec.proxyNetNumberOfBoxes = sec.netNumberOfBoxes;
                  sec.proxyGrossNumberOfBoxes = sec.grossNumberOfBoxes;
                  sec.checked = true;
                  val.check = true;
                  allSectorIds["sectoren"].push(sec);
                  sectorStatus = sec.sectorStatus;
                 this.createStatus(this.allocatedSearchObjects[gewest]['provinces'][province].info,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].municipality,val.originalSubmuni,sectorStatus);
                  //this.checkStatusProvince(this.allocatedSearchObjects[gewest]['provinces'][province].info,sectorStatus);
                  this.addSectorTypeMessage(sec.distributionCodeA,sec.distributionCodeB,sec.distributionCodeX,sec.sectorType);
                  if(sec.sectorStatus == true){
                    if(lang == "NL"){
                       this.totalBoxesNl = this.totalBoxesNl + Number(sec.netNumberOfBoxes);
                     }
                     if(lang == "FR"){
                        this.totalBoxesFr = this.totalBoxesFr + Number(sec.netNumberOfBoxes);
                     }
                      if(lang == "BIL"){
                          this.totalBoxesBil = this.totalBoxesBil + Number(sec.netNumberOfBoxes);
                     }
                    if(lang == "NL & FR"){
                        this.totalBoxesNlFr = this.totalBoxesNlFr + Number(sec.netNumberOfBoxes);
                    }
                    if(lang == "FR & DE"){
                        this.totalBoxesDuFr = this.totalBoxesDuFr + Number(sec.netNumberOfBoxes);
                    }
                    this.totalGrossBoxes = this.totalGrossBoxes + Number(sec.grossNumberOfBoxes);
                     this.totalNetBoxes =  this.totalNetBoxes + Number(sec.netNumberOfBoxes);
                  }


                   if(!this.allSectors.includes(sec.sector_id)){
                      this.allSectors.push(sec.sector_id);
                    }
                });
            });
            this.sendValues();
            this.calculatePrice();
          }
          this.toggleSectors(checked, allSectorIds, sectorStatus);
        }
        if(type == 'province'){
           let allSectorIds = [];
          if(!allSectorIds["sectoren"]){
            allSectorIds["sectoren"] = [];
          }
          let arr = this.allocatedSearchObjects[gewest]['provinces'][province];
          var actualGewest = this.allocatedSearchObjects[gewest];
           if(checked == false){
                  Object.values(arr.municipalities).forEach((mun) => {
                    Object.values(mun.submunicipalities).forEach((sub) => {
                      Object.values(sub.sectoren).forEach((sec) => {
                        sec.proxyNetNumberOfBoxes = 0;
                        sec.proxyGrossNumberOfBoxes = 0;
                        let lang =  sec.languageCode;
                        allSectorIds["sectoren"].push(sec);
                        sectorStatus = sec.sectorStatus;
                        this.deleteStatus(this.allocatedSearchObjects[gewest]['provinces'][province].info,mun.municipality,sub.originalSubmuni,sectorStatus);
                        this.eraseSectorTypeMessage(sec.distributionCodeA,sec.distributionCodeB,sec.distributionCodeX,sec.sectorType);
                        if(sec.sectorStatus == true){
                          if(lang == "NL"){
                              if(sec.checked == false){
                                this.totalBoxesNl = this.totalBoxesNl + Number(sec.netNumberOfBoxes);
                              }
                              this.totalBoxesNl = this.totalBoxesNl - Number(sec.netNumberOfBoxes);
                           }
                         if(lang == "FR"){
                          if(sec.checked == false){
                            this.totalBoxesFr = this.totalBoxesFr + Number(sec.netNumberOfBoxes);
                          }
                           this.totalBoxesFr = this.totalBoxesFr - Number(sec.netNumberOfBoxes);
                         }
                        if(lang == "BIL"){
                            if(sec.checked == false){
                               this.totalBoxesBil = this.totalBoxesBil + Number(sec.netNumberOfBoxes);
                            }
                          this.totalBoxesBil = this.totalBoxesBil - Number(sec.netNumberOfBoxes);
                         }
                         if(lang == "NL & FR"){
                          if(sec.checked == false){
                            this.totalBoxesNlFr = this.totalBoxesNlFr + Number(sec.netNumberOfBoxes);
                          }
                          this.totalBoxesNlFr = this.totalBoxesNlFr - Number(sec.netNumberOfBoxes);
                        }
                          if(lang == "FR & DE"){
                            if(sec.checked == false){
                              this.totalBoxesDuFr = this.totalBoxesDuFr + Number(sec.netNumberOfBoxes);
                            }
                            this.totalBoxesDuFr = this.totalBoxesDuFr - Number(sec.netNumberOfBoxes);
                          }
                          if(sec.checked == false){
                              this.totalGrossBoxes = this.totalGrossBoxes + Number(sec.grossNumberOfBoxes);
                              this.totalNetBoxes =  this.totalNetBoxes + Number(sec.netNumberOfBoxes);
                          }
                          this.totalGrossBoxes = this.totalGrossBoxes - Number(sec.grossNumberOfBoxes);
                          this.totalNetBoxes =  this.totalNetBoxes - Number(sec.netNumberOfBoxes);
                       }

                       sec.checked = false;
                        sub.checked = false;
                        mun.checked = false;
                        this.eraseFromTotals(sec.sector_id);
                    });
                  });
              });
            this.sendValues();
            this.calculatePrice();
           }
           if(checked == true){
              if(Object.prototype.hasOwnProperty.call(arr,'municipalities') != false){
                Object.values(arr.municipalities).forEach((mun) => {
                  if(this.weightValidationFirst == '' || this.weightValidationFirst == "invalid"){
                      this.mapState = "empty";
                  }
                  Object.values(mun.submunicipalities).forEach((sub) => {
                  Object.values(sub.sectoren).forEach((sec) => {
                    sec.proxyNetNumberOfBoxes = sec.netNumberOfBoxes;
                    sec.proxyGrossNumberOfBoxes = sec.grossNumberOfBoxes;
                    let lang =  sec.languageCode;
                    sec.checked = true;
                    sub.checked = true;
                    mun.checked = true;
                    arr.checked = true;
                    allSectorIds["sectoren"].push(sec);
                    sectorStatus = sec.sectorStatus;
                    this.createStatus(this.allocatedSearchObjects[gewest]['provinces'][province].info,mun.municipality,sub.originalSubmuni,sectorStatus);
                    this.addSectorTypeMessage(sec.distributionCodeA,sec.distributionCodeB,sec.distributionCodeX,sec.sectorType);
                    if(sec.sectorStatus == true){
                      if(lang == "NL"){
                        this.totalBoxesNl = this.totalBoxesNl + Number(sec.netNumberOfBoxes);
                      }
                      if(lang == "FR"){
                        this.totalBoxesFr = this.totalBoxesFr + Number(sec.netNumberOfBoxes);
                      }
                      if(lang == "BIL"){
                        this.totalBoxesBil = this.totalBoxesBil + Number(sec.netNumberOfBoxes);
                      }
                      if(lang == "NL & FR"){
                        this.totalBoxesNlFr = this.totalBoxesNlFr + Number(sec.netNumberOfBoxes);
                      }
                      if(lang == "FR & DE"){
                        this.totalBoxesDuFr = this.totalBoxesDuFr + Number(sec.netNumberOfBoxes);
                      }
                      this.totalGrossBoxes = this.totalGrossBoxes + Number(sec.grossNumberOfBoxes);
                      this.totalNetBoxes =  this.totalNetBoxes + Number(sec.netNumberOfBoxes);
                     }

                    if(!this.allSectors.includes(sec.sector_id)){
                      this.allSectors.push(sec.sector_id);
                    }
                  });
                });
              });
              if(Object.keys(arr.municipalities).length == 0){
                this.searchAdd('province','',actualGewest.info,arr.info,'','','',arr.checked,'','',false);
              }
              }
              this.sendValues();
              this.calculatePrice();
              if(Object.prototype.hasOwnProperty.call(arr,'municipalities') == false){
               // console.log('we komen hier door een gewest aan te klikken');
               // console.log(arr.info);
                this.searchSingle(arr.info,'province','');
              }
           }
          this.toggleSectors(checked, allSectorIds, sectorStatus);
        }
        if(type == 'gewest'){
          let allSectorIds = [];
          if(!allSectorIds["sectoren"]){
            allSectorIds["sectoren"] = [];
          }
          let arr = this.allocatedSearchObjects[gewest];
          //let lang =  this.allocatedSearchObjects[gewest]['languageCode'];
           if(checked == false){
            if(Object.prototype.hasOwnProperty.call(arr,'provinces') == true){
              Object.values(arr.provinces).forEach((prov) => {
               if(Object.prototype.hasOwnProperty.call(prov,'municipalities') == true){
                Object.values(prov.municipalities).forEach((mun) => {
                Object.values(mun.submunicipalities).forEach((sub) => {
                  Object.values(sub.sectoren).forEach((sec) => {
                    sec.proxyNetNumberOfBoxes = 0;
                    sec.proxyGrossNumberOfBoxes = 0;
                   let lang =  sec.languageCode;
                      allSectorIds["sectoren"].push(sec);
                        if(lang == "NL"){
                          if(sec.checked == false){
                            this.totalBoxesNl = this.totalBoxesNl + Number(sec.netNumberOfBoxes);
                          }
                          this.totalBoxesNl = this.totalBoxesNl - Number(sec.netNumberOfBoxes);
                       }
                       if(lang == "FR"){
                        if(sec.checked == false){
                          this.totalBoxesFr = this.totalBoxesFr + Number(sec.netNumberOfBoxes);
                        }
                         this.totalBoxesFr = this.totalBoxesFr - Number(sec.netNumberOfBoxes);
                       }
                      if(lang == "BIL"){
                          if(sec.checked == false){
                             this.totalBoxesBil = this.totalBoxesBil + Number(sec.netNumberOfBoxes);
                          }
                        this.totalBoxesBil = this.totalBoxesBil - Number(sec.netNumberOfBoxes);
                       }
                       if(lang == "NL & FR"){
                        if(sec.checked == false){
                          this.totalBoxesNlFr = this.totalBoxesNlFr + Number(sec.netNumberOfBoxes);
                        }
                        this.totalBoxesNlFr = this.totalBoxesNlFr - Number(sec.netNumberOfBoxes);
                      }
                        if(lang == "FR & DE"){
                          if(sec.checked == false){
                            this.totalBoxesDuFr = this.totalBoxesDuFr + Number(sec.netNumberOfBoxes);
                          }
                          this.totalBoxesDuFr = this.totalBoxesDuFr - Number(sec.netNumberOfBoxes);
                        }
                        if(sec.checked == false){
                            this.totalGrossBoxes = this.totalGrossBoxes + Number(sec.grossNumberOfBoxes);
                            this.totalNetBoxes =  this.totalNetBoxes + Number(sec.netNumberOfBoxes);
                        }
                       this.totalGrossBoxes = this.totalGrossBoxes - Number(sec.grossNumberOfBoxes);
                       this.totalNetBoxes =  this.totalNetBoxes - Number(sec.netNumberOfBoxes);
                       sec.checked = false;
                        sub.checked = false;
                        mun.checked = false;
                        prov.checked = false;
                        this.eraseFromTotals(sec.sector_id);
                  });
                });
              });
              }
            });
            }
            this.sendValues();
            this.calculatePrice();
            this.mapState = "empty";
           }
           if(checked == true){
            //console.log('komen we in gewest yes');
            if(Object.prototype.hasOwnProperty.call(arr,'provinces') == true){
               Object.values(arr.provinces).forEach((prov) => {
                if(Object.prototype.hasOwnProperty.call(prov,'municipalities') == true){
                  Object.values(prov.municipalities).forEach((mun) => {
                    Object.values(mun.submunicipalities).forEach((sub) => {
                      Object.values(sub.sectoren).forEach((sec) => {
                        //this.createStatus(prov.info,mun.municipality,sub.originalSubmuni,sec.sectorStatus);
                        sec.proxyNetNumberOfBoxes = sec.netNumberOfBoxes;
                        sec.proxyGrossNumberOfBoxes = sec.grossNumberOfBoxes;
                        sec.checked = true;
                        sub.checked = true;
                        mun.checked = true;
                        prov.checked = true;
                        let lang =  sec.languageCode;
                        //this.createStatus(prov.info,mun.municipality,sub.originalSubmuni,sec.sectorStatus);
                        allSectorIds["sectoren"].push(sec);
                        if(lang == "NL"){
                        this.totalBoxesNl = this.totalBoxesNl + Number(sec.netNumberOfBoxes);
                       }
                       if(lang == "FR"){
                        this.totalBoxesFr = this.totalBoxesFr + Number(sec.netNumberOfBoxes);
                       }
                        if(lang == "BIL"){
                        this.totalBoxesBil = this.totalBoxesBil + Number(sec.netNumberOfBoxes);
                       }
                       if(lang == "NL & FR"){
                          this.totalBoxesNlFr = this.totalBoxesNlFr + Number(sec.netNumberOfBoxes);
                        }
                        if(lang == "FR & DE"){
                          this.totalBoxesDuFr = this.totalBoxesDuFr + Number(sec.netNumberOfBoxes);
                        }
                       this.totalGrossBoxes = this.totalGrossBoxes + Number(sec.grossNumberOfBoxes);
                       this.totalNetBoxes =  this.totalNetBoxes + Number(sec.netNumberOfBoxes);
                       if(!this.allSectors.includes(sec.sector_id)){
                          this.allSectors.push(sec.sector_id);
                        }
                      });
                    });
                  });
                }
                });
                this.sendValues();
                this.calculatePrice();
                this.mapState = "empty";
            }else{
              this.getProvinces(gewest,checked);
              this.mapState = "empty";
            }
          }
          this.toggleSectors(checked, allSectorIds);
        }
        if(type == "sectoren-quit"){
          let allSectorIds = [];
          // counter switch
          /*let length =  Object.keys(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren']).length;*/
          /*this.deleteStatusMunicipality(this.allocatedSearchObjects[gewest]['provinces'][province],this.provinceStatus[this.allocatedSearchObjects[gewest]['provinces'][province].info],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].sectorStatus);*/
          let i = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].counter;
          if(i > 0){
            this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['counter'] = i - 1;
          }
           if(i == 0){
            this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['completion'] = true;
          }
          if(!allSectorIds["sectoren"]){
            allSectorIds["sectoren"] = [this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]];
          }
          this.eraseSectors(allSectorIds);
          this.deleteStatus(this.allocatedSearchObjects[gewest]['provinces'][province].info,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].municipality,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].originalSubmuni,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].sectorStatus);
          this.eraseFromTotals(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id].sector_id);
          this.eraseSectorTypeMessage(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeA'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeB'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['distributionCodeX'],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id]['sectorType']);
          this.sendValues();
          let lang =  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['languageCode'];
          let arr = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id];
          let sectorStatus = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].sectorStatus;
          if(sectorStatus == true){
            if(lang == "NL"){
              if(this.totalBoxesNl != 0){
                if(arr.checked == false){
                   this.totalBoxesNl = this.totalBoxesNl + Number(arr.netNumberOfBoxes);
                }
                this.totalBoxesNl = this.totalBoxesNl - Number(arr.netNumberOfBoxes);
              }
            }
            if(lang == "FR"){
              if(this.totalBoxesFr != 0){
                if(arr.checked == false){
                  this.totalBoxesFr = this.totalBoxesFr + Number(arr.netNumberOfBoxes);
                }
                this.totalBoxesFr = this.totalBoxesFr - Number(arr.netNumberOfBoxes);
              }
            }
            if(lang == "BIL"){
              if(this.totalBoxesBil != 0){
                if(arr.checked == false){
                  this.totalBoxesBil = this.totalBoxesBil + Number(arr.netNumberOfBoxes);
                }
                this.totalBoxesBil = this.totalBoxesBil - Number(arr.netNumberOfBoxes);
              }
            }
            if(lang == "NL & FR"){
              if(this.totalBoxesNlFr != 0){
                if(arr.checked == false){
                  this.totalBoxesNlFr = this.totalBoxesNlFr + Number(arr.netNumberOfBoxes);
                }
                this.totalBoxesNlFr = this.totalBoxesNlFr - Number(arr.netNumberOfBoxes);
              }
            }
            if(lang == "FR & DE"){
              if(this.totalBoxesDuFr != 0){
                if(arr.checked == false){
                  this.totalBoxesDuFr = this.totalBoxesDuFr + Number(arr.netNumberOfBoxes);
                }
                this.totalBoxesDuFr = this.totalBoxesDuFr - Number(arr.netNumberOfBoxes);
              }
            }
            if(this.totalGrossBoxes != 0){
              if(arr.checked == false){
                this.totalGrossBoxes = this.totalGrossBoxes + Number(arr.grossNumberOfBoxes);
              }
              this.totalGrossBoxes = this.totalGrossBoxes - Number(arr.grossNumberOfBoxes);
            }
            if(this.totalNetBoxes != 0){
              if(arr.checked == false){
                this.totalNetBoxes =  this.totalNetBoxes + Number(arr.netNumberOfBoxes);
              }
              this.totalNetBoxes =  this.totalNetBoxes - Number(arr.netNumberOfBoxes);
            }
          }
            //});
          if(Object.keys(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren']).length == 1){
            delete this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id];
            delete this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality];
            delete this.arrPlacedSectors[sector_id];
          }else{
            delete this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id];
            delete this.arrPlacedSectors[sector_id];
          }
          this.calculatePrice();
        }
        if(type == "submuni-quit"){
          let allSectorIds = [];
          if(!allSectorIds["sectoren"]){
            allSectorIds["sectoren"] = [];
          }
          /*this.deleteStatusMunicipality(this.allocatedSearchObjects[gewest]['provinces'][province],this.provinceStatus[this.allocatedSearchObjects[gewest]['provinces'][province].info],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality],this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].sectorStatus);*/

           // counter switch
          let lengthMuni =  Object.keys(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities']).length;
          let i = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].counter;

          this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['counter'] = i;
          if(lengthMuni == 1){
            this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['completion'] = true;
          }
          let lang =  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['languageCode'];
          let arr = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality];
          let sectorStatus = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].sectorStatus;
          Object.values(arr.sectoren).forEach((el) => {
          allSectorIds["sectoren"].push(el);
          this.deleteStatus(this.allocatedSearchObjects[gewest]['provinces'][province].info,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].municipality,this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].originalSubmuni,el.sectorStatus);
          this.eraseSectorTypeMessage(el.distributionCodeA,el.distributionCodeA,el.distributionCodeX,el.sectorType);
          if(sectorStatus == true){
            if(lang == "NL"){
                if(this.totalBoxesNl != 0){
                  if(arr.checked == false){
                    this.totalBoxesNl = this.totalBoxesNl + Number(el.netNumberOfBoxes);
                  }
                  this.totalBoxesNl = this.totalBoxesNl - Number(el.netNumberOfBoxes);
                }
              }
              if(lang == "FR"){
                if(this.totalBoxesFr != 0){
                  if(arr.checked == false){
                    this.totalBoxesFr = this.totalBoxesFr + Number(el.netNumberOfBoxes);
                  }
                  this.totalBoxesFr = this.totalBoxesFr - Number(el.netNumberOfBoxes);
                }
              }
              if(lang == "BIL"){
                if(this.totalBoxesBil != 0){
                  if(arr.checked == false){
                    this.totalBoxesBil = this.totalBoxesBil + Number(el.netNumberOfBoxes);
                  }
                  this.totalBoxesBil = this.totalBoxesBil - Number(el.netNumberOfBoxes);
                }
              }
              if(lang == "NL & FR"){
                if(this.totalBoxesNlFr != 0){
                  if(arr.checked == false){
                    this.totalBoxesNlFr = this.totalBoxesNlFr + Number(el.netNumberOfBoxes);
                  }
                   this.totalBoxesNlFr = this.totalBoxesNlFr - Number(el.netNumberOfBoxes)
                }
              }
              if(lang == "FR & DE"){
                if(this.totalBoxesDuFr != 0){
                  if(arr.checked == false){
                    this.totalBoxesDuFr = this.totalBoxesDuFr + Number(el.netNumberOfBoxes);
                  }
                  this.totalBoxesDuFr = this.totalBoxesDuFr - Number(el.netNumberOfBoxes);
                }
              }
            if(arr.checked == false){
              this.totalGrossBoxes = this.totalGrossBoxes + Number(el.grossNumberOfBoxes);
              this.totalNetBoxes =  this.totalNetBoxes + Number(el.netNumberOfBoxes);
             }
             this.totalGrossBoxes = this.totalGrossBoxes - Number(el.grossNumberOfBoxes);
            this.totalNetBoxes =  this.totalNetBoxes - Number(el.netNumberOfBoxes);
            this.eraseFromTotals(el.sector_id);
            delete this.arrPlacedSectors[el.sector_id];
            delete this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren'][sector_id];
          }
          });
          if(Object.keys(this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['sectoren']).length == 1){
            delete this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality];

          }else{
            delete this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality];
          }
          this.eraseSectors(allSectorIds);
          this.sendValues();
          this.calculatePrice();
        }
        if(type == "muni-quit"){
          let allSectorIds = [];
          if(!allSectorIds["sectoren"]){
            allSectorIds["sectoren"] = [];
          }
          let lang =  this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['languageCode'];
          let arr = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality];
          Object.values(arr.submunicipalities).forEach((el) => {
             Object.values(el.sectoren).forEach((sec) => {
             this.deleteStatus(this.allocatedSearchObjects[gewest]['provinces'][province].info,arr.municipality,el.originalSubmuni,sec.sectorStatus);
              this.eraseSectorTypeMessage(sec.distributionCodeA,sec.distributionCodeA,sec.distributionCodeX,sec.sectorType);
              var sectorStatus = sec.sectorStatus;
              allSectorIds["sectoren"].push(sec);
              if(sectorStatus == true){
               if(lang == "NL"){
                if(this.totalBoxesNl != 0){
                  if(sec.checked == false){
                    this.totalBoxesNl = this.totalBoxesNl + Number(sec.netNumberOfBoxes);
                  }
                  this.totalBoxesNl = this.totalBoxesNl - Number(sec.netNumberOfBoxes);
                }
              }
              if(lang == "FR"){
                if(this.totalBoxesFr != 0){
                  if(sec.checked == false){
                    this.totalBoxesFr = this.totalBoxesFr + Number(sec.netNumberOfBoxes);
                  }
                  this.totalBoxesFr = this.totalBoxesFr - Number(sec.netNumberOfBoxes);
                }
              }
              if(lang == "BIL"){
                if(this.totalBoxesBil != 0){
                  if(sec.checked == false){
                    this.totalBoxesBil = this.totalBoxesBil + Number(sec.netNumberOfBoxes);
                  }
                  this.totalBoxesBil = this.totalBoxesBil - Number(sec.netNumberOfBoxes);
                }
              }
              if(lang == "NL & FR"){
                if(this.totalBoxesNlFr != 0){
                  if(sec.checked == false){
                    this.totalBoxesNlFr = this.totalBoxesNlFr + Number(sec.netNumberOfBoxes);
                  }
                  this.totalBoxesNlFr = this.totalBoxesNlFr - Number(sec.netNumberOfBoxes);
                }
              }
              if(lang == "FR & DE"){
                if(this.totalBoxesDuFr != 0){
                  if(sec.checked == false){
                    this.totalBoxesDuFr = this.totalBoxesDuFr +Number(sec.netNumberOfBoxes);
                  }
                  this.totalBoxesDuFr = this.totalBoxesDuFr - Number(sec.netNumberOfBoxes);
                }
              }
              if(sec.checked == false){
                this.totalGrossBoxes = this.totalGrossBoxes + Number(sec.grossNumberOfBoxes);
                this.totalNetBoxes =  this.totalNetBoxes + Number(sec.netNumberOfBoxes);
              }
              this.totalGrossBoxes = this.totalGrossBoxes - Number(sec.grossNumberOfBoxes);
              this.totalNetBoxes =  this.totalNetBoxes - Number(sec.netNumberOfBoxes);
              this.eraseFromTotals(sec.sector_id);
              delete this.arrPlacedSectors[sec.sector_id];
            }
            });
          });
            delete this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality];
            this.eraseSectors(allSectorIds);
            this.sendValues();
            this.calculatePrice();
        }
        if(type == "province-quit"){
          let allSectorIds = [];
          if(!allSectorIds["sectoren"]){
            allSectorIds["sectoren"] = [];
          }
          //let lang =  this.allocatedSearchObjects[gewest]['provinces'][province]['languageCode'];
          let arr = this.allocatedSearchObjects[gewest]['provinces'][province];
          Object.values(arr.municipalities).forEach((el) => {
            Object.values(el.submunicipalities).forEach((muni) => {
             Object.values(muni.sectoren).forEach((sec) => {
            let lang =  sec.languageCode;
            allSectorIds["sectoren"].push(sec);
            if(lang == "NL"){
                if(this.totalBoxesNl != 0){
                  if(sec.checked == false){
                    this.totalBoxesNl = this.totalBoxesNl + Number(sec.netNumberOfBoxes);
                  }
                  this.totalBoxesNl = this.totalBoxesNl - Number(sec.netNumberOfBoxes);
                }
              }
              if(lang == "FR"){
                if(this.totalBoxesFr != 0){
                  if(sec.checked == false){
                    this.totalBoxesFr = this.totalBoxesFr + Number(sec.netNumberOfBoxes);
                  }
                  this.totalBoxesFr = this.totalBoxesFr - Number(sec.netNumberOfBoxes);
                }
              }
              if(lang == "BIL"){
                if(this.totalBoxesBil != 0){
                  if(sec.checked == false){
                    this.totalBoxesBil = this.totalBoxesBil + Number(sec.netNumberOfBoxes);
                  }
                  this.totalBoxesBil = this.totalBoxesBil - Number(sec.netNumberOfBoxes);
                }
              }
              if(lang == "NL & FR"){
                if(this.totalBoxesNlFr != 0){
                  if(sec.checked == false){
                    this.totalBoxesNlFr = this.totalBoxesNlFr + Number(sec.netNumberOfBoxes);
                  }
                  this.totalBoxesNlFr = this.totalBoxesNlFr - Number(sec.netNumberOfBoxes);
                }
              }
              if(lang == "FR & DE"){
                if(this.totalBoxesDuFr != 0){
                  if(sec.checked == false){
                    this.totalBoxesDuFr = this.totalBoxesDuFr + Number(sec.netNumberOfBoxes);
                   }
                   this.totalBoxesDuFr = this.totalBoxesDuFr - Number(sec.netNumberOfBoxes);
                }
              }
              if(sec.checked == false){
                this.totalGrossBoxes = this.totalGrossBoxes + Number(sec.grossNumberOfBoxes);
                this.totalNetBoxes =  this.totalNetBoxes + Number(sec.netNumberOfBoxes);
              }
              this.totalGrossBoxes = this.totalGrossBoxes - Number(sec.grossNumberOfBoxes);
              this.totalNetBoxes =  this.totalNetBoxes - Number(sec.netNumberOfBoxes);
              this.eraseFromTotals(sec.sector_id);
            });
           });
          });
          delete this.allocatedSearchObjects[gewest]['provinces'][province];
          this.eraseSectors(allSectorIds);
          this.sendValues();
          this.calculatePrice();
        }
        if(type == "gewest-quit"){
          let allSectorIds = [];
          if(!allSectorIds["sectoren"]){
            allSectorIds["sectoren"] = [];
          }
          let lang =  this.allocatedSearchObjects[gewest]['languageCode'];
          let arr = this.allocatedSearchObjects[gewest];
          Object.values(arr.provinces).forEach((prov) => {
            Object.values(prov.municipalities).forEach((muni) => {
              Object.values(muni.submunicipalities).forEach((submuni) => {
               Object.values(submuni.sectoren).forEach((sec) => {
                if(lang == "NL"){
                this.totalBoxesNl = this.totalBoxesNl - Number(sec.netNumberOfBoxes);
                }
                if(lang == "FR"){
                  this.totalBoxesFr = this.totalBoxesFr - Number(sec.netNumberOfBoxes);
                }
                if(lang == "BIL"){
                  this.totalBoxesBil = this.totalBoxesBil - Number(sec.netNumberOfBoxes);
                }
                if(lang == "NL & FR"){
                  this.totalBoxesNlFr = this.totalBoxesNlFr - Number(sec.netNumberOfBoxes);
                }
                if(lang == "FR & DE"){
                    this.totalBoxesDuFr = this.totalBoxesDuFr - Number(sec.netNumberOfBoxes);
                }
                allSectorIds["sectoren"].push(sec);
                this.totalGrossBoxes = this.totalGrossBoxes - Number(sec.grossNumberOfBoxes);
                this.totalNetBoxes =  this.totalNetBoxes - Number(sec.netNumberOfBoxes);
              });
             });
            });
          });
          delete this.allocatedSearchObjects[gewest];
          this.eraseSectors(allSectorIds);
        }
       }
    },
    toggleChecked(item){
      item.checked = !item.checked;
    },
    toggleProvincesLoaded(){
      if(this.provincesLoaded == false){
        this.provincesLoaded = true;
      }else if(this.provincesLoaded == true){
        this.provincesLoaded = false;
      }
    },
    calculateBoxesSubmuni(data,id,status,gewest,province,municipality,submunicipality){
      let output = 0;
      let grossboxes = 0;
      Object.values(data).forEach((val) => {
        output = output + Number(val.proxyNetNumberOfBoxes);
        grossboxes = grossboxes + Number(val.grossBoxes);
      });
      this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['boxes'] = output;
      this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality]['grossBoxes'] = grossboxes;
      if(output == 0){
         this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].checked = false;
      }else{
          this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'][submunicipality].checked = true;
        }
      return output.toLocaleString('nl');
     },
    calculateBoxesMunicipalities(gewest,province,municipality){
      let output = 0;
      let arr = this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality]['submunicipalities'];
          Object.values(arr).forEach((val) => {
            Object.values(val.sectoren).forEach((el) => {
                output = output + Number(el.proxyNetNumberOfBoxes);
            });
          });
         if(output == 0){
          this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].checked = false;
        }else{
          this.allocatedSearchObjects[gewest]['provinces'][province]['municipalities'][municipality].checked = true;
        }
        //this.searchAdd("checks");
      return output.toLocaleString('nl');
     },
    calculateBoxesProvinces(gewest,province){
      let output = 0;
      let arr = this.allocatedSearchObjects[gewest]['provinces'][province];
      if(Object.prototype.hasOwnProperty.call(this.allocatedSearchObjects[gewest]['provinces'][province],'municipalities') == true){
        Object.values(arr.municipalities).forEach((el) => {
          Object.values(el.submunicipalities).forEach((subm) => {
            Object.values(subm.sectoren).forEach((sec) => {
              output = output + Number(sec.proxyNetNumberOfBoxes);
            });
          });
        });
      }
      if(output == 0){
        this.allocatedSearchObjects[gewest]['provinces'][province].checked = false;
      }else{
        this.allocatedSearchObjects[gewest]['provinces'][province].checked = true;
      }
      return output.toLocaleString('nl');
     },
    calculateBoxesGewesten(key){
      let output = 0;
      switch(key) {
        case "Vlaams Gewest":
          output = this.boxesVlaamsGewest;
          break;
        case "Brussel Hoofdstedelijk Gewest":
          output = this.boxesBxl;
          break;
        case "Région Wallonne":
          output = this.boxesWallone;
          break;
      }
      return output.toLocaleString('nl');
     },
    eraseFromTotals(id){
      this.allSectors = this.allSectors.filter(function(item) {
        return item !== id
      });
    },
    sendValues(){
      let data = {
        sectors: this.allSectors
      }
      this.$emit('values-second', data);
    }
  },
}


</script>
